<template>
  <div class="design bg-color">
    <studyHeader></studyHeader>
    <div class="container m-0 container-style">
      <div class="has-header">
        <transition name="slide-fade">
          <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 pl-0 pr-40" v-on:click="previousQuestion()">
            <div class="panel panel-default panel-style side-bar" v-if="step !== 0">
              <div class="panel-body"></div>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2" v-if="step === 0">
            <div class="panel-body panel-body-style col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title pb-20">
                  We are now going to walk you through a series of questions. Your answers will help us setup your study today and influence improvements we make in the future.
                </div>
                <div class="question_title pb-20">
                  This process will help us start begin building your:
                </div>
                <div class="row pb-20">
                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6">
                    <div>
                      <img src="static/img/graphic-study-app.svg" />
                    </div>
                    <div class="pt-5">Mobile Study App</div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 pt-30">
                    <div>
                      <img src="static/img/graphic-cloud.svg" />
                    </div>
                    <div class="pt-5">Compliant Cloud</div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <div>
                      <img src="static/img/graphic-portal.svg" />
                    </div>
                    <div class="pt-5">Research Portal</div>
                  </div>
                </div>
                <div class="form-group pt-20">
                  <button type="button" class="btn btn-md btn-info btn-style col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25" v-on:click="nextQuestion()">
                    Begin
                  </button>
                </div>
                <div class="row mt-200 studyDeleteIcon" v-if="clientId_DoNot_Delete_Flag">
                  <div>
                    <b-form-checkbox v-model="doNotDeleteStudyFlag" inline> </b-form-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2" v-if="step === 1">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title pb-20">
                  {{ questionsList[step].question }}
                </div>
                <select class="form-control select-style" v-model="questionnaire.clientId" required>
                  <option value="default" disabled>-Select-</option>
                  <option v-for="(client, index) in questionsList[step].clients" :value="client.id" :key="index">{{ client.name }}</option>
                </select>
                <div class="form-group pt-20">
                  <button
                    type="button"
                    class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25"
                    v-on:click="nextQuestion()"
                    :class="{
                      disabledbtn: questionnaire.clientId == 'default'
                    }"
                    :disabled="questionnaire.clientId == 'default'"
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pt-30">
              <span class="cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 2">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title">
                  {{ questionsList[step].question }}
                </div>
                <div class="question_title fs-12 pt-5 pb-20">
                  Don't worry! You can change this later.
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    v-on:keyup="validStudyName(questionnaire.name)"
                    name="study-name"
                    :class="{
                      input: true,
                      'is-danger': errors.has('study-name'),
                      'is-success': !errors.has('study-name')
                    }"
                    class="form-control"
                    v-model="questionnaire.name"
                    placeholder="Enter study name"
                    required
                  />
                  <span v-if="questionnaire.name && questionnaire.name.length > 50" class="error-style">Study name cannot exceed 50 characters in length</span>
                  <br />
                  <span v-if="validStudyNameValue" class="error-style">Study name cannot start and/or end with a space.</span>
                </div>
                <div class="form-group pt-20">
                  <button
                    type="button"
                    class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25"
                    v-on:click.prevent="nextQuestion()"
                    :class="{
                      disabledbtn: !questionnaire.name || errors.any()
                    }"
                    :disabled="validStudyNameValue"
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pb-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 3">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title pb-20">
                  {{ questionsList[step].question }}
                </div>
                <div v-for="(option, index) in questionsList[step].options" :key="index">
                  <button type="button" class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 mt-10 br-25" v-on:click="buttonSelected(option, step)">
                    {{ option }}
                  </button>
                </div>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pt-30">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 4">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title pb-20">We’re happy to help.</div>
                <div class="question_title">
                  Please give us a call at
                  <span class="color_blue">+1 888-948-4732</span>
                </div>
                <div class="question_title pb-20">
                  or email us at
                  <a href="mailto:support@threadresearch.com"><span class="color_blue">support@threadresearch.com.</span></a>
                </div>
                <button type="button" class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 mt-10 br-25" v-on:click="nextQuestion()">
                  Continue
                </button>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pt-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 5">
            <div class="panel-body panel-body-style col-lg-8 set-full-width col-md-10">
              <div class="">
                <div class="question_title">
                  {{ questionsList[step].question }}
                </div>
                <div class="countries-wrap">
                  <b-form-group class="country-group">
                    <b-form-checkbox v-for="option in supportedCountries" v-model="selectedCountries" :key="option.countryId" :value="option" :checked="true" inline :disabled="option.isDisabled">
                      {{ option.countryName }}
                    </b-form-checkbox>
                  </b-form-group>
                </div>
                <button type="button" class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 mt-10 br-25" v-on:click="nextQuestion()">
                  Continue
                </button>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pt-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 6">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class>
                <div class="question_title">
                  {{ questionsList[step].question }}
                </div>
                <div class="lang-para-approved">
                  The languages selected here will be available across all sites. Languages can then be configured at each individual site and you will only be able to choose from the languages you specify here.
                </div>
                <div class="pt-20">
                  <select class="form-control select-style mt-10" v-on:change="selectedLanguage(selLanguage)" v-model="selLanguage">
                    <option value="null" disabled>Select a language</option>
                    <option v-for="(lang, index) in questionsList[step].languages" :value="lang" :key="index">{{ lang.name }}</option>
                  </select>
                  <div class="clearfix" v-for="(lang, index) in questionnaire.studyLanguage" :key="index">
                    <div class="btn-container" v-if="lang.active != false">
                      <label v-if="lang && lang.language_culture" class="lang-cult">{{ lang.language_culture }}</label>
                      <div class="selected-lang pt-10 latin-america-popover" v-if="lang.display_name == 'Spanish (Latin America)'">
                        Spanish (<span id="popover-latin-america" class="latin-america-text" @click="sortLatinArray" tabindex="0">Latin America</span>)
                        <div class="text-center">
                          <b-popover target="popover-latin-america" triggers="click blur" container="activity-library-table__container">
                            <div class="activity-library-table__language-pop-over-container">
                              <ul class="activity-library-table__languages-list">
                                <li class="activity-library-table__languages-list-item" v-for="(latin, index) in latinAmericaLanguages" :key="index">
                                  {{ latin }}
                                </li>
                              </ul>
                            </div>
                          </b-popover>
                        </div>
                      </div>
                      <div v-else class="selected-lang pt-10">
                        {{ lang.display_name }}
                      </div>
                      <label class="draft-label" v-if="lang.name != 'English' && lang.draft">Draft</label>
                      <button class="set-btn" v-if="lang.name != 'English' && lang.draft" @click="changeLangMode(lang)">
                        Set to Visible
                      </button>
                      <button class="set-btn" v-if="lang.name != 'English' && !lang.draft" @click="changeLangMode(lang)">
                        Set to Draft
                      </button>
                      <div class="remove-selected pt-10" v-if="lang.name != 'English'" @click="showRemoveLanguageModal(lang, index)">
                        Remove
                      </div>
                    </div>
                  </div>
                </div>
                <div class="selected-lang pt-20 pb-20 lang-note" v-if="getActiveLanguageCount() > 1">
                  <span><b>Note:</b></span>
                  <span>Languages can be set to draft to prevent them from being visible during translation</span>
                </div>
                <div class="form-group pt-20">
                  <button type="button" class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25" :disabled="isContinueBtnDisabled" v-on:click="nextQuestion()">
                    Continue
                  </button>
                </div>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pb-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
            <!-- modal box -->
            <b-modal ref="remove-language-modal" hide-footer hide-header>
              <div class="d-block text-center">
                <div class="title">
                  Are you sure you want to remove this language?
                </div>
                <div class="description">
                  Please be advised that this does not remove the language if it is currently in use in the study by a participant. Future participants will not see this language.
                </div>
                <div class="btn-grp">
                  <button class="cancel-btn" @click="removeLanguage(false)">
                    Cancel
                  </button>
                  <button class="confirm-btn" @click="removeLanguage(true)">
                    Yes
                  </button>
                </div>
              </div>
            </b-modal>
          </div>
        </transition>

        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 7">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class>
                <div class="question_title">
                  {{ questionsList[step].question }}
                </div>
                <div v-for="(country, index) in selectedCountries" v-bind:key="country.countryId">
                  <div class="single-country-box" v-b-toggle="'country-id-' + index">
                    <div class="col-lg-6 text-left">
                      <span class="country-name">{{ country.countryName }}</span>
                    </div>
                    <div class="col-lg-6 text-right">
                      <i class="fa fa-caret-down" data-fa-transform="rotate-90" aria-hidden="true"></i>
                      <span>{{ linkedLC[country.countryId].length }} of {{ filteredStudyLanguage.length }}</span>
                    </div>
                  </div>
                  <b-collapse :id="'country-id-' + index" visible>
                    <div class="lang-group">
                      <b-form-group>
                        <b-form-checkbox v-for="option in filteredStudyLanguage" v-model="linkedLC[country.countryId]" :value="option.language_id" :key="option.name" @input="updateForcedLanguage" v-b-popover.hover.top="option.name" inline>{{ option.name }} </b-form-checkbox>
                      </b-form-group>
                    </div>
                  </b-collapse>
                </div>
                <div class="form-group pt-20">
                  <button type="button" class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25" :disabled="isContinueBtnDisabled" v-on:click="nextQuestion()">
                    Continue
                  </button>
                </div>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pb-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>

        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 8">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class>
                <div class="question_title" v-if="showUploadFileSection">
                  {{ questionsList[step].question0 }}
                </div>
                <div class="question_title" v-if="showUploadReadOnlySection">
                  {{ questionsList[step].question1 }}
                </div>
                <div class="upload-file" v-if="showUploadFileSection && questionnaire.language.length > 1">
                  <div class="pt-50">
                    <span class="round">1</span
                    ><label class="upload-wrap">
                      Upload settings file
                      <input type="file" size="60" class="upload-properties" id="upload-file-input" v-on:change="saveUploadFileOnLocal($event)" accept=".applanga" />
                    </label>
                  </div>
                  <div class="pt-15 access-token-wrap">
                    <span class="round">2</span><span class="display-inline"><input class="form-control api-input" type="text" v-on:blur="checkForAccessToken()" v-model="applangaAccessToken" name="applangaAccessToken" placeholder="Enter API token"/></span>
                  </div>
                  <div class="form-group pt-50">
                    <button disabled="isContinueBtnDisabled" type="button" class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25" v-on:click="nextQuestion()">
                      Continue
                    </button>
                  </div>
                  <div class="ps-note pt-55">
                    <a target="_blank" href="https://thread.zendesk.com/hc/en-us/articles/360031643471">How do I find my settings file and API token?</a>
                  </div>
                </div>
                <div class="remove-upload-file" v-if="showUploadReadOnlySection">
                  <div class="pt-70 clearfix">
                    <div class="up-title pb-5">Uploaded</div>
                    <div class="upload">
                      <div class="upload-area">
                        <div><i class="fa fa-file" aria-hidden="true"></i>{{ settingFile.currentFile.displayName }}</div>
                      </div>
                      <div class="del-link" @click="showDeletetransaltionModal()">
                        Remove
                      </div>
                    </div>
                  </div>
                  <div class="form-group pt-100">
                    <button type="button" class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25" v-on:click="nextQuestion()">
                      Continue
                    </button>
                  </div>
                  <div class="ps-note pt-25">
                    <a target="_blank" href="https://thread.zendesk.com/hc/en-us/articles/360031643471">How do I download a settings file?</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pb-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
            <b-modal ref="del-transaltion-modal" hide-footer hide-header>
              <div class="d-block text-center">
                <div class="title">
                  Are you sure you want to remove this file?
                </div>
                <div class="btn-grp">
                  <button class="cancel-btn" @click="delTransaltion(false)">
                    Cancel
                  </button>
                  <button class="confirm-btn" @click="delTransaltion(true)">
                    Yes
                  </button>
                </div>
              </div>
            </b-modal>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 9">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title">
                  {{ questionsList[step].question }}
                </div>
                <div class="pb-20">Enter up to 6.</div>
                <div v-for="(answer, index) in questionnaire.targetPatients" :key="index">
                  <span class="icon-style" v-on:click="removeTargetPatients(answer)">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </span>
                  <span class="form-control select-style mt-10 pl-28 patient_population_readonly" required>{{ answer }}</span>
                </div>
                <div class="form-group">
                  <div class="dropdown" v-on:keyup.stop.prevent="navigateDisease($event)" v-show="questionnaire.targetPatients.length < 6">
                    <input
                      class="form-control input-style dropdown-toggle"
                      type="text"
                      id="diseaseDropdown"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      v-if="patiantInput"
                      v-model="selected"
                      placeholder="Describe population"
                      v-validate="'required'"
                      name="study_population"
                      :class="{
                        input: true,
                        'is-danger': errors.has('study_population'),
                        'is-success': !errors.has('study_population')
                      }"
                    />
                    <span v-show="errors.has('study_population')" class="error-style">Please enter participant population</span>
                    <ul
                      class="dropdown-menu target-patients"
                      aria-labelledby="diseaseDropdown"
                      v-show="studySearchedDiseases.length !== 0 && selected.length !== 0"
                      :class="{
                        show: studySearchedDiseases.length !== 0 && selected.length !== 0
                      }"
                    >
                      <li v-for="(studyDisease, diseaseIndex) in studySearchedDiseases" :key="diseaseIndex">
                        <a
                          class="text-center cursor_pointer"
                          :class="{
                            'navigate-dropdown': populationIndex === diseaseIndex
                          }"
                          v-on:click.stop.prevent="selectedPatientPopulations(studyDisease)"
                          v-on:mouseover.stop.prevent="populationIndex = diseaseIndex"
                        >
                          <span
                            :class="{
                              'color-white': populationIndex === diseaseIndex
                            }"
                            >{{ studyDisease }}</span
                          >
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="form-group">
                  <div class="link-style" v-if="questionnaire.targetPatients.length < 6">
                    <span class="cursor_pointer" v-on:click="selectedPatientPopulations(selected)" :class="{ disabled_input: errors.has('population') }">Add another participant population</span>
                  </div>
                </div>
                <div class="form-group">
                  <div class="question_title fs-16">
                    Is this a rare disease study?
                  </div>
                  <div class="enable-disable">
                    <b-form-radio-group class="fs-14 mt-14" v-model="questionnaire.rareDisease" :options="isRareDiseaseOptions"></b-form-radio-group>
                  </div>
                </div>
                <div class="pt-10" v-if="showAlert">
                  Please enter 6 participant population
                </div>
                <div class="mt-10 error_msg" v-if="showAlertOther">
                  Please enter another participant population
                </div>
                <div class="pt-20">
                  <button type="button" class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25 br-25" v-on:click="nextQuestion()" :disabled="isContinueButtonDisabled">Continue</button>
                </div>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pb-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 10">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title pb-20">
                  {{ questionsList[step].question }}
                </div>
                <select class="form-control select-style" v-model="questionnaire.type" required>
                  <option value="default" disabled>-Select-</option>
                  <option v-for="(option, index) in questionsList[step].options" :value="option" :key="index">{{ option }}</option>
                </select>
                <div v-if="questionnaire.type === 'Other'">
                  <b-form-input class="custom-study-textarea" id="textarea" v-model="customStudyType" placeholder="Please enter your study type"></b-form-input>
                </div>
                <div class="form-group pt-20">
                  <button
                    type="button"
                    class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25"
                    v-on:click="nextQuestion()"
                    :class="{
                      disabledbtn: questionnaire.type === 'default' || (questionnaire.type === 'Other' && !customStudyType.trim().length) || !questionnaire.type.length
                    }"
                    :disabled="questionnaire.type === 'default' || (questionnaire.type === 'Other' && !customStudyType.trim().length) || !questionnaire.type.length"
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pt-30">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 11">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title_cohort mb-56">
                  Participant enrollment and randomization
                </div>
                <div class="question_title pb-16 text-left">
                  Will the study participants be invited to enroll in the study (Digital invitation) or can any participant enroll directly by only passing self-reported inclusion/exclusion criteria within the study app (Open enrollment)?
                </div>
                <div class="text-left">
                  <b-form-group>
                    <b-form-radio-group v-model="questionnaire.subType" :options="questionsList[step].options" name="subType" class="fw-300" plain></b-form-radio-group>
                  </b-form-group>
                </div>
                <div class="horiziontal-rule-line-break mt-48 mb-48"></div>
                <div class="text-left">
                  <p class="rtsm-text roboto-medium-font">Will your study need a Randomization and Trial Supply Management (RTSM) integration?</p>
                  <p class="mb-16">The RTSM or Interactive Response Technology (IRT) integration automates participant status flows and participant IDs between systems.</p>
                  <div class="d-flex flex-row">
                    <div id="rtsm-check" class="mt-2">
                      <input type="checkbox" v-model="questionnaire.hasRTSMIntegration" :disabled="isStudyActive()" data-testid="use-rtsm-integration-check" />
                    </div>
                    <div class="ml-8">
                      <p class="mb-0">Yes, enable the RTSM integration.</p>
                      <p class="fs-12 mb-32">(A prior contract and work order must be established with the RTSM Vendor.)</p>
                    </div>
                    <b-tooltip :disabled="!isStudyActive()" target="rtsm-check" placement="right" triggers="hover">
                      <rtsmTooltipContent :message="questionnaire.hasRTSMIntegration ? 'RTSM integrations are locked once a study is live.' : 'RTSM integration selection is locked once a study is live.'" />
                    </b-tooltip>
                  </div>
                </div>
                <div v-if="questionnaire.hasRTSMIntegration" class="text-left pb-48" data-testid="rtsm-warning-message">
                  <p>Adding an RTSM integration will <span class="underline">automatically lock the following settings:</span></p>
                  <div class="rtsm-settings-wrapper">
                    <table class="rtsm-settings" aria-describedby="RTSM locked settings">
                      <tr>
                        <th id="rtsm-participant-id" class="fw-bold">Participant ID settings</th>
                        <th id="rtsm-participant-id-blank"></th>
                      </tr>
                      <tr>
                        <td>Participant ID required</td>
                        <td><span class="fas fa-solid fa-lock mr-5"></span>Off</td>
                      </tr>
                      <tr>
                        <td>Participant ID is editable</td>
                        <td><span class="fas fa-solid fa-lock mr-5"></span>Off</td>
                      </tr>
                      <tr>
                        <td>Configure formatting</td>
                        <td><span class="fas fa-solid fa-lock mr-5"></span>Off</td>
                      </tr>
                      <tr>
                        <td>Allow duplicate Participant IDs</td>
                        <td><span class="fas fa-solid fa-lock mr-5"></span>Off</td>
                      </tr>
                      <tr>
                        <th id="rtsm-study-settings" class="fw-bold">Study settings</th>
                        <th id="rtsm-study-settings-blank"></th>
                      </tr>
                      <tr>
                        <td>Manually Start Study for Participants</td>
                        <td><span class="fas fa-solid fa-lock mr-5"></span>Enable</td>
                      </tr>
                      <tr>
                        <td>Scheduled Study Start</td>
                        <td><span class="fas fa-solid fa-lock mr-5"></span>Immediate Start</td>
                      </tr>
                      <tr>
                        <th id="rtsm-consent-settings" class="fw-bold">eConsent settings</th>
                        <th id="rtsm-consent-settings-blank"></th>
                      </tr>
                      <tr>
                        <td>These settings will change based on your selection on the RTSM Integration page.</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="form-group mt-32">
                <button type="button" class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25" v-on:click.prevent="nextQuestion()" :class="{ disabledbtn: !questionnaire.subType }" :disabled="!questionnaire.subType">Continue</button>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pb-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 12">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title pb-20">
                  {{ questionsList[step].question }}
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    v-validate="'required|numeric|between:1,999999|min_value:1|max_value:999999'"
                    name="number-of-patients"
                    :class="{ input: true, 'is-danger': errors.has('number-of-patients'), 'is-success': !errors.has('number-of-patients') }"
                    class="form-control input-style"
                    v-model="questionnaire.expectedPatients"
                    placeholder="Enter number"
                    min="1"
                    v-on:input="numberValidation()"
                    v-no-leading-zero
                    required
                  />
                  <span v-show="numberValidationFlag" class="error-style">Please enter integers from 1 to 999999</span>
                  <span v-show="rangeValidationFlag" class="error-style">Please enter a number between 1 and 999999</span>
                </div>
                <div class="form-group pt-20">
                  <button type="button" class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25" v-on:click.prevent="nextQuestion()" :class="{ disabledbtn: numberValidationFlag || rangeValidationFlag || errors.has('number-of-patients') || !questionnaire.expectedPatients }">Continue</button>
                </div>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pt-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-9 col-sm-10 col-xs-10 br-2 " v-if="step === 13">
            <div class="panel-body panel-body-style col-lg-9 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title pb-5">
                  {{ questionsList[step].question }}
                </div>
                <div class="pb-20">
                  Configuring the Participant ID determines what actions can be taken on the Participant ID and the settings of those actions.
                </div>
                <div class="form-group text-center">
                  <span class="pr-20 description-text">Participant ID required</span>
                  <label class="switch">
                    <span class="text-span">Off</span>
                    <input type="checkbox" v-model="questionnaire.isParticipantIdRequired" :disabled="questionnaire.hasRTSMIntegration" data-testid="participant-id-required-check" />
                    <div class="slider round" id="participant-id-required"></div>
                    <span class="text-span on">On</span>
                  </label>
                  <b-tooltip :disabled="!questionnaire.hasRTSMIntegration" target="participant-id-required" placement="right" triggers="hover">
                    <rtsmTooltipContent />
                  </b-tooltip>
                </div>
                <div class="form-group">
                  <span class="pr-20 description-text">Participant ID is editable</span>
                  <label class="switch">
                    <span class="text-span">Off</span>
                    <input type="checkbox" v-model="questionnaire.isParticipantIdEditable" :disabled="questionnaire.hasRTSMIntegration" data-testid="participant-id-editable-check" />
                    <div class="slider round" id="participant-id-editable"></div>
                    <span class="text-span on">On</span>
                  </label>
                  <b-tooltip :disabled="!questionnaire.hasRTSMIntegration" target="participant-id-editable" placement="right" triggers="hover" data-testid="participant-id-editable-tooltip">
                    <rtsmTooltipContent />
                  </b-tooltip>
                </div>
                <div class="form-group">
                  <span>Configure any specific formatting needed for how the Participant ID gets entered below.</span>
                  <div class="form-group pt-15">
                    <span class="pr-20 description-text">Configure formatting</span>
                    <label class="switch">
                      <span class="text-span">Off</span>
                      <input type="checkbox" v-model="questionnaire.participantIdFormatConfigured.isFormattingChecked" @change="showConfigurationDetail($event)" :disabled="questionnaire.hasRTSMIntegration" data-testid="configure-formatting-check" />
                      <div class="slider round" id="configure-formatting"></div>
                      <span class="text-span on">On</span>
                    </label>
                    <b-tooltip :disabled="!questionnaire.hasRTSMIntegration" target="configure-formatting" placement="right" data-testid="configure-formatting-tooltip" triggers="hover">
                      <rtsmTooltipContent />
                    </b-tooltip>
                  </div>
                </div>
                <transition name="slide">
                  <div class="configure-formatting" v-if="isConfigurationDetailSectionEnabled">
                    <div class="header">
                      <span><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span>
                      <span>Note: Once your study is live, the below formatting becomes locked and no changes can be made.</span>
                    </div>
                    <div class="body">
                      <div class="form-group pt-30">
                        <div>
                          <span class="pr-20">Restrict the number of characters</span>
                          <label class="">
                            <input type="text" class="input-type" placeholder="Enter number" :value="questionnaire.participantIdFormatConfigured.size" @keyup="sizeChangeDetection($event)" />
                          </label>
                        </div>
                        <div class="error-message error-style">
                          {{ questionnaire.participantIdFormatConfigured.errors }}
                        </div>
                      </div>
                      <div class="form-group">
                        <span class="pr-5">Edit the ID format</span>
                        <span id="participantIdConfigurationInfo"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
                        <b-popover target="participantIdConfigurationInfo" triggers="hover">
                          <template v-slot:content>
                            <div class="popover-content">
                              <div>
                                Enter how the ID should be formatted below. Use a space as a variable and include any separators, such as dashes. Anything that is not a space will be permanent and cannot be altered.
                              </div>
                              <div><b>Example:</b> If you enter a format of _ _ _2YY-419_ _ _YYY, a sample ID could be abc2YY-419123YYY.</div>
                            </div>
                          </template>
                        </b-popover>
                        <div class="pt-5 edit-participant-id">
                          <div class="otp-input scrollbar">
                            <otpInputService :options="questionnaire.participantIdFormatConfigured" v-for="(digit, index) in formatArray" :key="index" v-model="formatArray[index]" :showOldFormat="false"></otpInputService>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                      </div>
                      <div class="form-group additional-settings">
                        <span class="pr-20 description-text additional font-size pb-7">Additional format settings</span>
                        <div class="form-group pl-10 checkbox-label">
                          <input class="hidden-input" type="checkbox" v-model="questionnaire.participantIdFormatConfigured.isDisallowLetters" />
                          <span class="input-checkbox"></span>
                          <span class="checkbox-text">Disallow letters</span>
                        </div>
                        <div class="form-group pl-10 checkbox-label">
                          <input class="hidden-input" type="checkbox" v-model="questionnaire.participantIdFormatConfigured.isDisallowNumbers" />
                          <span class="input-checkbox"></span>
                          <span class="checkbox-text">Disallow numbers</span>
                        </div>
                        <div class="form-group pl-10 checkbox-label">
                          <input class="hidden-input" type="checkbox" v-model="questionnaire.participantIdFormatConfigured.isDisallowSpecialCharacters" />
                          <span class="input-checkbox"></span>
                          <span class="checkbox-text">Disallow special characters (^[@.#&+-]*$)</span>
                        </div>
                      </div>
                      <div class="form-group additional-settings">
                        <span class="pr-20 description-text additional font-size pb-7">Color format settings</span>
                        <div class="form-group pl-10 checkbox-label">
                          <input class="hidden-input" type="checkbox" v-model="questionnaire.participantIdFormatConfigured.colorCodingEnable" @change="checkColorCodingEnable($event)" />
                          <span class="input-checkbox"></span>
                          <span class="checkbox-text">Add color coding</span>
                        </div>
                      </div>
                      <div class="form-group pb-10">
                        <div class="row" v-if="questionnaire.participantIdFormatConfigured.colorCodingEnable == true">
                          <div v-for="(digit, index) in questionnaire.participantIdColorCodingMetaData" :key="`colorSetting-${index}`">
                            <div class="ml-0 pl-0 additional-settings" :class="[digit.colorCodeCondition == '' || digit.colorCodeCondition == 'None' ? { 'col-sm-4': '0px' } : { 'col-sm-2': '0px' }]">
                              <span class="">Character</span>
                              <label class="">
                                <input type="text" class="input-type" placeholder="Enter place" v-model="digit.colorCodeCharacter" @input="isNumber($event, digit, index) && characterChangeDetection(digit, index)" />
                              </label>
                            </div>
                            <div class="col-sm-4 select_section pl-0 pr-0 additional-settings">
                              <span class="">Conditional Logic</span>
                              <select name="userRole" class="form-control br-3 input-bg pt-2" placeholder="Select logic" v-model="digit.colorCodeCondition" v-on:change="selectedColorConditionLogic(digit, index)">
                                <option v-for="logic in conditionLogic" v-bind:value="logic.value" :key="logic.value"> {{ logic.name }}</option>
                              </select>
                            </div>
                            <div class="col-sm-2 pr-0 additional-settings" v-if="digit.colorCodeCondition == 'Is equal to' || digit.colorCodeCondition == 'Is not equal to'">
                              <span class="">Value</span>
                              <label class="">
                                <input type="text" class="input-type" placeholder="Enter place" v-model="digit.colorCodeConditionValue" @input="colorCodeConditionValueDetection($event, digit, index)" />
                              </label>
                            </div>
                            <div class="col-sm-2 select_section" :style="[digit.colorCodeCondition == 'Is equal to' || digit.colorCodeCondition == 'Is not equal to' ? { 'padding-right': '15px' } : { 'padding-right': '0px' }]">
                              <span class="">Color</span>
                              <!-- CUSTOM COLOR PICKER STARTS HERE-->
                              <div class="wrapper-dropdown colorDropdown">
                                <span @click="toggleDropdown(index)" v-html="selectedValueColor(index)" class="dropdown-type"></span>
                                <ul class="dropdown" v-show="questionnaire.participantIdColorCodingMetaData[index].active">
                                  <li v-for="(color, colorInd) in participateIdColorOptions" @click="setColor(color.colorCode, color.name, index)" :key="colorInd">
                                    <span :style="{ background: color.colorCode }"></span>
                                  </li>
                                </ul>
                              </div>
                              <!-- CUSTOM COLOR PICKER ENDS HERE-->
                            </div>
                            <div class="col-sm-2" :style="[digit.colorCodeCondition == 'Is equal to' || digit.colorCodeCondition == 'Is not equal to' ? { 'padding-left': '0px' } : {}]">
                              <span class="">&nbsp;</span>
                              <div class="remove-block">
                                <img src="/static/img/econsent/delete.svg" class="delete-btn pt-7 pl-7" v-on:click.prevent="deleteColorConfigAlert(index)" />
                              </div>
                            </div>
                            <div v-if="digit.errorChar">
                              <div class="col-sm-12">
                                <span class="err-msg">{{ digit.errorChar }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row link-style" v-if="questionnaire.participantIdFormatConfigured.colorCodingEnable == true && displayAddColorCodeBtn">
                          <span class="cursor_pointer" v-on:click.prevent="addNewColorConfig()"> Add another color code</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
                <!---Configure PID's Uniqueness -->
                <div class="form-group">
                  <span class="pr-22 pt-10 description-text-2">Allow duplicate Participant IDs</span>
                  <label class="switch pr-66">
                    <span class="text-span">Off</span>
                    <input type="checkbox" v-model="questionnaire.allowDuplicatePid" :disabled="questionnaire.hasRTSMIntegration" data-testid="allow-duplicate-ids-check" />
                    <div class="slider round" id="duplicate-pid"></div>
                    <span class="text-span on">On</span>
                  </label>
                  <b-tooltip :disabled="!questionnaire.hasRTSMIntegration" target="duplicate-pid" placement="right" triggers="hover" data-testid="allow-duplicate-ids-tooltip">
                    <rtsmTooltipContent />
                  </b-tooltip>
                </div>
              </div>
              <div class="form-group pt-20">
                <button type="button" class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25" v-on:click.prevent="nextQuestion()">
                  Continue
                </button>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pt-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 14">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title pb-30">
                  {{ questionsList[step].question }}
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="text-left">Study start date</div>
                    <div class="form-group">
                      <datepicker class="text-left" :disabledDates="disabledDates" input-class="datepicker-class form-control" placeholder="Select date" v-model="questionnaire.studyStartDate" format="MM/dd/yy" name="studyStartDate" v-on:selected="calculateStartEndDuration(questionnaire)"></datepicker>
                      <span class="cal-icon-style">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                      </span>
                      <span class="icon_style"></span>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="text-left">Study end date</div>
                    <div class="form-group">
                      <datepicker class="text-left" :disabledDates="disabledDates" input-class="datepicker-class form-control" placeholder="Select date" v-model="questionnaire.studyEndDate" format="MM/dd/yy" name="studyEndDate" v-on:selected="calculateStartEndDuration(questionnaire)"></datepicker>
                      <span class="cal-icon-style">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                      </span>
                      <span class="icon_style"></span>
                      <span class="days_number" v-if="questionnaire.studyStartDate && questionnaire.studyEndDate">
                        <span v-if="questionnaire.startEndDuration">{{ questionnaire.startEndDuration }} Days</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="text-left">First participant enrolled</div>
                    <div class="form-group">
                      <datepicker class="text-left" :disabledDates="disabledDates" input-class="datepicker-class form-control" placeholder="Select date" v-model="questionnaire.firstPatientEnrollDate" v-on:selected="calculateWeeks(questionnaire)" format="MM/dd/yy" name="firstPatientEnrollDate"></datepicker>
                      <span class="cal-icon-style">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                      </span>
                      <span class="icon_style"></span>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding:0">
                        <div class="text-left last_day">
                          First participant's last day in the study
                        </div>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding:0">
                        <div class="form-group">
                          <datepicker class="text-left" :disabledDates="disabledDates" input-class="datepicker-class form-control" placeholder="Select date" v-model="questionnaire.firstPatientLastDate" v-on:selected="calculateWeeks(questionnaire)" format="MM/dd/yy" name="firstPatientLastDate"></datepicker>
                          <span class="cal-icon-style-study">
                            <i class="fa fa-calendar-o" aria-hidden="true"></i>
                          </span>
                          <span class="icon_style-study"></span>
                          <span class="days_number-study" v-if="questionnaire.firstPatientEnrollDate && questionnaire.firstPatientLastDate">
                            <span v-if="questionnaire.studyDuration">{{ questionnaire.studyDuration }} Days</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-10">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="text-left">Last participant enrolled</div>
                    <div class="form-group">
                      <datepicker
                        class="text-left"
                        :class="{
                          disabled_datepicker: questionnaire.continuousStudy
                        }"
                        :disabledDates="disabledDates"
                        input-class="datepicker-class form-control"
                        placeholder="Select date"
                        v-model="questionnaire.lastPatientEnrollDate"
                        format="MM/dd/yy"
                        v-on:selected="calculateLatPatientDuration(questionnaire)"
                      ></datepicker>
                      <span class="cal-icon-style">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                      </span>
                      <span class="icon_style"></span>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding :0">
                        <div class="text-left last_day">
                          Last participant's last day in the study
                        </div>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding :0">
                        <div class="form-group">
                          <datepicker
                            class="text-left"
                            :class="{
                              disabled_datepicker: questionnaire.continuousStudy
                            }"
                            :disabledDates="disabledDates"
                            input-class="datepicker-class form-control"
                            placeholder="Select date"
                            v-model="questionnaire.lastPatientLastDate"
                            format="MM/dd/yy"
                            v-on:selected="calculateLatPatientDuration(questionnaire)"
                          ></datepicker>
                          <span class="cal-icon-style-study">
                            <i class="fa fa-calendar-o" aria-hidden="true"></i>
                          </span>
                          <span class="icon_style-study"></span>
                          <span class="days_number-study" v-if="questionnaire.lastPatientEnrollDate && questionnaire.lastPatientLastDate">
                            <span v-if="questionnaire.lastPatientDuration">{{ questionnaire.lastPatientDuration }} Days</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row text-left pl-15">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="questionnaire.continuousStudy" v-on:change="studyContinuousChanged(questionnaire.continuousStudy)" />
                      <span class="pt-5"> Study is continuous</span>
                    </label>
                  </div>
                </div>
                <div class="form-group pt-20">
                  <button
                    type="button"
                    class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25"
                    v-on:click="nextQuestion()"
                    :class="{
                      disabledbtn:
                        (!questionnaire.continuousStudy && (!questionnaire.studyStartDate || !questionnaire.studyEndDate || !questionnaire.firstPatientEnrollDate || !questionnaire.firstPatientLastDate || !questionnaire.lastPatientEnrollDate || !questionnaire.lastPatientLastDate)) ||
                        (questionnaire.continuousStudy && (!questionnaire.studyStartDate || !questionnaire.studyEndDate || !questionnaire.firstPatientEnrollDate || !questionnaire.firstPatientLastDate))
                    }"
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pb-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 15">
            <div class="panel-body panel-body-style col-lg-11 col-lg-offset-1 col-md-11 col-md-offset-1 pb-0">
              <div class="">
                <div class="question_title_cohort pb-10 fs-20">
                  Identify Study Cohorts
                </div>
                <div class="question_title pb-20 fs-14 pad-150">
                  Cohorts are used to define participant populations that require a different schedule of events.
                </div>
                <div class="form-group">
                  <span class="pr-0 description-text cohort-text">Configure cohorts</span>
                  <label class="switch">
                    <span class="text-span">Off</span>
                    <input type="checkbox" v-model="questionnaire.isSegmentSupported" v-on:change="studyCohortChanged(questionnaire.isSegmentSupported)" />
                    <div class="slider round"></div>
                    <span class="text-span on">On</span>
                  </label>
                </div>
                <div v-if="questionnaire.isSegmentSupported === true">
                  <div class="card mb-15" v-if="questionnaire.segments && questionnaire.segments.length > 0">
                    <div class="card-header row text-left" id="headingOne" v-for="(cohort, index) in questionnaire.segments" :key="index">
                      <div class="col col-lg-8 verrticle">
                        <b>{{ cohort.name }} </b><span class="ml-15 mr-5 badge badge-blue_light d-inline-block">{{ setcohorts(cohort) ? setcohorts(cohort) : 0 }}</span>
                        <h5 class="fs-13 d-inline-block">Milestones</h5>
                      </div>
                      <div class="col col-lg-4 text-right verrticle">
                        <span class="cohortEdit" @click="editCohort(cohort)">Edit</span>
                      </div>
                    </div>
                  </div>
                  <div class="row pt-0" v-if="showAddCohortScreen == true">
                    <div class="col-lg-2"></div>
                    <form class="cohort_form offset-lg-1 col-8">
                      <div class="form-group">
                        <label for="">Cohort Name</label>
                        <input id="input" type="text" placeholder="Please name your cohort" class="form-control" maxlength="20" v-model.trim="cohort.name" @input="disabledCohort()" required />
                      </div>
                      <div class="form-group">
                        <label for="">Defined By</label><span class="ml-15 fs-12 text-muted">(optional)</span>
                        <input type="text" class="form-control" maxlength="500" v-model.trim="cohort.description" placeholder="Please define your cohort" />
                      </div>

                      <div class="row">
                        <div class="mb-10 btn p-0">
                          <button type="button" class="cancel-btn1" @click="cancelCohort()">
                            Cancel
                          </button>
                        </div>
                        <div class="ml-15 mb-10 btn p-0">
                          <button type="button" class="cohort-add-btn" :disabled="isDisabled" @click="saveCohort()">
                            Add
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="row pt-0" v-if="showEditCohortScreen == true">
                    <div class="col-lg-2"></div>
                    <form class="cohort_form offset-lg-1 col-8">
                      <div class="form-group">
                        <label for="">Cohort Name</label>
                        <input type="text" class="form-control" placeholder="Please name your cohort" maxlength="20" v-model.trim="cohort.name" required />
                      </div>
                      <div class="form-group">
                        <label for="">Defined By</label><span class="ml-15 fs-12 text-muted">(optional)</span>
                        <input type="text" class="form-control" maxlength="500" v-model.trim="cohort.description" placeholder="Please define your cohort" />
                      </div>
                      <div class="row">
                        <div class="mb-10 btn p-0">
                          <button type="button" class="cohort-add-btn" @click="copyCohort()">
                            Copy Cohort
                          </button>
                        </div>
                        <div class="ml-15 mb-10 btn p-0">
                          <button type="button" class="cohort-add-btn" @click="deleteCohort()">
                            Delete Cohort
                          </button>
                        </div>
                      </div>
                      <div class="row float-right">
                        <div class="mb-10 btn p-0">
                          <button type="button" class="cancel-btn1" @click="cancelEditCohort()">
                            Cancel
                          </button>
                        </div>
                        <div class="ml-15 mb-10 btn p-0">
                          <button type="button" class="cohort-add-btn" data-toggle="modal" data-target="#cohortEditModal">
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="link-style pb-20 another_link">
                    <span class="cursor_pointer" v-on:click="addCohort()">Add another cohort</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-body panel-body-style col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title_cohort pb-10 fs-20">
                  {{ questionsList[step].question }}
                </div>
                <div class="question_title pb-20 fs-14 pr-40 pl-40">
                  This is your schedule of events. No matter when a participant enrolls, they will follow the same milestone cadence. You will be able to use these milestones later for scheduling tasks.
                </div>
                <div class="form-group">
                  <span class="pr-0 description-text cohort-text">Configure milestones</span>
                  <label class="switch">
                    <span class="text-span">Off</span>
                    <input type="checkbox" v-model="questionnaire.isMilestoneSupported" />
                    <div class="slider round"></div>
                    <span class="text-span on">On</span>
                  </label>
                </div>
                <div class="form-group" v-if="questionnaire.isMilestoneSupported">
                  <div class="row h-29">
                    <div class="col-md-5 offset-md-3">
                      <span class="description-text cohort-text">Enable Screening Milestone</span>
                      <label class="switch">
                        <span class="text-span">Off</span>
                        <input type="checkbox" v-model="questionnaire.screeningMilestoneAllowed" />
                        <div class="slider round"></div>
                        <span class="text-span on">On</span>
                      </label>
                    </div>
                    <div class="col-md-4">
                      <template v-if="questionnaire.screeningMilestoneAllowed">
                        <div class="row">
                          <div class="col-md-7 p-0">
                            <span class="scr-duration-title">Screening Duration</span>
                          </div>
                          <div class="col-md-5 p-0 pl-2">
                            <div class="row">
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 p-0">
                                <input type="number" class="form-control scr-milestone-number" v-model.number="questionnaire.screeningDuration" placeholder="0" min="0" required />
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 fs-13 custom-days-block">
                                <span class="day_text">Days</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div v-if="questionnaire.isMilestoneSupported == true">
                  <div class="question_title fs-14">
                    Participant consent occurs on Day 0. To create a milestone on the day of participant consent, please also use Day 0.
                  </div>
                  <div class="question_title fs-14 ">
                    You may choose to name your milestone with a max 18 character length.
                  </div>
                  <div class="question_title fs-14 pl-20 pr-20">
                    Duration -/+ fields define the time period in days before and/or after the study day the subject visit can occur according to the study protocol. Screening milestones will be configured in the amount of days proceeding the start date.
                  </div>
                </div>
              </div>
            </div>
            <div class="container pl-25 pr-30">
              <div v-if="questionnaire.isMilestoneSupported == true">
                <template v-if="questionnaire.screeningMilestoneAllowed">
                  <div class="row">
                    <div :class="['position col-lg-4 col-md-6 col-sm-6 col-xs-6', questionnaire.isSegmentSupported ? 'pb-40' : 'pb-20']" v-for="(milestone, index) in questionnaire.screeningMilestoneList" :key="index">
                      <div class="p-0 pt-6 fs-14 text-left">Screening Milestone {{ index + 1 }}</div>
                      <div class="milestone-wrap">
                        <div class="top-wrapper">
                          <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 pr-0 pl-0">
                            <span class="span-block day_text">Name</span>
                          </div>
                          <div class="col-lg-8 col-md-6 col-sm-6 col-xs-6 p-0">
                            <input type="text" class="border-none form-control milestone_number" v-model.trim="questionnaire.screeningMilestoneList[index].milestoneName" v-bind:placeholder="'Milestone ' + (index + 1)" required />
                          </div>
                        </div>
                        <div class="middel-wrapper">
                          <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 pr-0 pl-0">
                            <span class="span-block day_text">Day</span>
                          </div>
                          <div class="col-lg-8 col-md-6 col-sm-6 col-xs-6 p-0">
                            <div class="row">
                              <div class="col-md-2">
                                <span class="fs-22 day_text px-2 custom-minus">
                                  -
                                </span>
                              </div>
                              <div class="col-md-10">
                                <input v-if="isConfiguredInActivity(questionnaire.screeningMilestoneList[index].milestoneId)" @input="cannotModifyMilestone(milestone)" type="number" class="border-none form-control milestone_number" :value="questionnaire.screeningMilestoneList[index].milestoneDay" placeholder="0" min="0" required />
                                <input v-else type="number" class="border-none form-control milestone_number" v-model.number="questionnaire.screeningMilestoneList[index].milestoneDay" placeholder="0" min="0" required />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="middel-wrapper">
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pr-0 pl-0">
                            <span class="span-block day_text">Duration -</span>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 p-0">
                            <input type="number" class="border-none form-control milestone_number" v-model.number="questionnaire.screeningMilestoneList[index].durationMinus" placeholder="0" min="0" required />
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pr-0 pl-0 days-block text-center">
                            <span class="day_text">Days</span>
                          </div>
                        </div>
                        <div class="bottom-wrapper">
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pr-0 pl-0">
                            <span class="span-block day_text">Duration +</span>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 p-0">
                            <input type="number" class="border-none form-control milestone_number" v-model.number="questionnaire.screeningMilestoneList[index].durationPlus" placeholder="0" min="0" required />
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pr-0 pl-0 days-block text-center">
                            <span class="day_text">Days</span>
                          </div>
                        </div>
                        <div class="bottom-wrapper" v-if="questionnaire.isSegmentSupported === true">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pl-0">
                            <span class="span-block day_text Ass_cohort_brdbtm">Assigned Cohorts</span>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 p-0 position-relative">
                            <div class="multiselect filter-form-box position-absolute" :id="'cohortSelectBox_' + index" :ref="'cohort-select' + index">
                              <div class="selectBox" @click="showCheckboxesCohort(index, 'screening')">
                                <div class="fakeclass">
                                  <input name="selCohort" class="form-control rounded-0 cursor-pointer d-block text-content" :value="getSelectedCohortText(questionnaire.screeningMilestoneList[index], index)" id="select-Cohort" readonly v-show="!isScreeningDisplayCohortCheckboxes[index]" />
                                </div>
                              </div>
                              <div :id="'showCheckboxesCohort' + index" class="select-scroll activity-builder-select-options showCheckCohort" v-if="isScreeningDisplayCohortCheckboxes[index]">
                                <b-form-checkbox-group v-model="milestone.segments">
                                  <div class="check_label_input d-flex" v-for="(cohort, cohortIndex) in questionnaire.segments" :key="cohort.id + milestone.milestoneId">
                                    <label class="mb-0" :for="'cohort_screening_checkbox_' + index + '_' + cohort.id">
                                      <b-form-checkbox class="Box" :id="'cohort_screening_checkbox_' + index + '_' + cohort.id" :value="cohort.id" @change="isCohortAdded($event, milestone, cohortIndex)" />
                                      {{ cohort.name }}</label
                                    >
                                  </div>
                                </b-form-checkbox-group>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span class="remove-icon-style" v-on:click="removeMilestone(milestone, index, 'screening')" v-if="milestone.showRemoveIcon">
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </span>
                      <div :class="['row text-left show-timeline', questionnaire.isSegmentSupported ? 'position-absolute mt-27' : '']">
                        <div class="checkbox pl-2 pt-5">
                          <label>
                            <input type="checkbox" class="Box shw_timeline_box" v-model="milestone.isDoNotShowTimeline" />
                          </label>
                          <span class="Do-not-show-on-timeline">Do not show on timeline</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="link-style pb-20 another_link mb-20" style="border-bottom:1px solid rgba(0,0,0,0.2)">
                    <span class="cursor_pointer" @click="addMilestone('screening')">Add another Screening milestone</span>
                  </div>
                </template>

                <template>
                  <div class="row">
                    <div :class="['position col-lg-4 col-md-6 col-sm-6 col-xs-6', questionnaire.isSegmentSupported ? 'pb-40' : 'pb-20']" v-for="(milestone, index) in questionnaire.milestonesList" :key="index">
                      <div class="p-0 pt-6 fs-14 text-left">Milestone {{ index + 1 }}</div>
                      <div class="milestone-wrap">
                        <div class="top-wrapper">
                          <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 pr-0 pl-0">
                            <span class="span-block day_text">Name</span>
                          </div>
                          <div class="col-lg-8 col-md-6 col-sm-6 col-xs-6 p-0">
                            <input type="text" class="border-none form-control milestone_number" v-model.trim="questionnaire.milestonesList[index].milestoneName" v-bind:placeholder="'Milestone ' + (index + 1)" required />
                          </div>
                        </div>
                        <div class="middel-wrapper">
                          <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 pr-0 pl-0">
                            <span class="span-block day_text">Day</span>
                          </div>
                          <div class="col-lg-8 col-md-6 col-sm-6 col-xs-6 p-0">
                            <input v-if="isConfiguredInActivity(questionnaire.milestonesList[index].milestoneId)" @input="cannotModifyMilestone(milestone)" type="number" class="border-none form-control milestone_number" :value="questionnaire.milestonesList[index].milestoneDay" placeholder="0" min="0" required />
                            <input v-else type="number" class="border-none form-control milestone_number" v-model.number="questionnaire.milestonesList[index].milestoneDay" placeholder="0" min="0" required />
                          </div>
                        </div>
                        <div class="middel-wrapper">
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pr-0 pl-0">
                            <span class="span-block day_text">Duration -</span>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 p-0">
                            <input type="number" class="border-none form-control milestone_number" v-model.number="questionnaire.milestonesList[index].durationMinus" placeholder="0" min="0" required />
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pr-0 pl-0 days-block text-center">
                            <span class="day_text">Days</span>
                          </div>
                        </div>
                        <div class="bottom-wrapper">
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pr-0 pl-0">
                            <span class="span-block day_text">Duration +</span>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 p-0">
                            <input type="number" class="border-none form-control milestone_number" v-model.number="questionnaire.milestonesList[index].durationPlus" placeholder="0" min="0" required />
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pr-0 pl-0 days-block text-center">
                            <span class="day_text">Days</span>
                          </div>
                        </div>
                        <div class="bottom-wrapper" v-if="questionnaire.isSegmentSupported === true">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pl-0">
                            <span class="span-block day_text Ass_cohort_brdbtm">Assigned Cohorts</span>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 p-0 position-relative">
                            <div class="multiselect filter-form-box position-absolute" :id="'cohortSelectBox_' + index" :ref="'cohort-select' + index">
                              <div class="selectBox" @click="showCheckboxesCohort(index, null)">
                                <div class="fakeclass">
                                  <input name="selCohort" class="form-control rounded-0 cursor-pointer d-block" :value="getSelectedCohortText(questionnaire.milestonesList[index], index)" id="select-Cohort" readonly v-show="!isMilestoneDisplayCohortCheckboxes[index]" />
                                </div>
                              </div>
                              <div :id="'showCheckboxesCohort' + index" class="select-scroll activity-builder-select-options showCheckCohort" v-if="isMilestoneDisplayCohortCheckboxes[index]">
                                <b-form-checkbox-group v-model="milestone.segments">
                                  <div class="check_label_input d-flex" v-for="(cohort, cohortIndex) in questionnaire.segments" :key="cohort.id + milestone.milestoneId">
                                    <label class="mb-0" :for="'cohort_checkbox_' + index + '_' + cohort.id">
                                      <b-form-checkbox class="Box" :id="'cohort_checkbox_' + index + '_' + cohort.id" :value="cohort.id" @change="isCohortAdded($event, milestone, cohortIndex)" />
                                      {{ cohort.name }}</label
                                    >
                                  </div>
                                </b-form-checkbox-group>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span class="remove-icon-style" v-on:click="removeMilestone(milestone, index, null)" v-if="milestone.showRemoveIcon">
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </span>
                      <div :class="['row text-left show-timeline', questionnaire.isSegmentSupported ? 'position-absolute mt-27' : '']">
                        <div class="checkbox pl-2 pt-5">
                          <label>
                            <input type="checkbox" class="Box shw_timeline_box" v-model="milestone.isDoNotShowTimeline" />
                          </label>
                          <span class="Do-not-show-on-timeline">Do not show on timeline</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="link-style pb-20 another_link">
                    <span class="cursor_pointer" v-on:click="addMilestone(null)">Add another milestone</span>
                  </div>
                </template>
              </div>
              <div class="form-group pt-20 text-center">
                <button
                  type="button"
                  class="btn btn-md btn-info btn-style col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3 col-xs-6 col-xs-offset-3 br-25"
                  v-on:click="nextQuestion()"
                  :class="{
                    disabledbtn: questionnaire.milestonesList.length < 1
                  }"
                  :disabled="questionnaire.milestonesList.length < 1"
                >
                  Continue
                </button>
              </div>
              <div class="link-style clearfix">
                <span class="cursor_pointer" v-on:click="dontSetupMilestones()" data-testid="no-milestones"> I do not want to set up milestones</span>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pb-10 mt-50">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 trigger-section" v-if="step === 16" @mouseover="addManualStartCustomClass()" @mouseleave="removeManualStartCustomClass()">
            <div class="text-align-center question_title pb-20 pt-50 fs-20 text-center">
              {{ questionsList[step].question }}
            </div>
            <div class="question_title pb-20 text-center fs-14">
              The Site Team determines when to start the study activities for each participant.
            </div>
            <div class="fs-14 text-center description">
              If enabled, all participants in the study will not start their schedule of events/activities until manually triggered by the Site Team from the Portal. The participant will also receive a manual start notification to confirm on their device before viewing or beginning any activities. Documents can be sent/signed and on-demand Telehealth Virtual Visits can be initiated by the Site
              Team prior to manually starting study activities.
            </div>
            <div class="enable-disable d-flex justify-content-center" :class="questionnaire.hasRTSMIntegration && 'enable-disable-disabled'">
              <b-form-radio-group id="manual-study-start" class="fs-14 text-center pt-25 pb-30 manual-start-radio" v-model="questionnaire.isManualStudyStart" :options="participantTriggerOptions" :disabled="questionnaire.hasRTSMIntegration" data-testid="manual-study-start-radio-group"></b-form-radio-group>
              <b-tooltip :disabled="!questionnaire.hasRTSMIntegration" target="manual-study-start" placement="right" triggers="hover">
                <rtsmTooltipContent />
              </b-tooltip>
            </div>
            <div class="fs-14 text-center">
              Day 0 can be used to send instructional or baseline activites to your participants.
            </div>
            <div v-if="questionnaire.isManualStudyStart" class="schedule-feature text-center mt-15">
              <div class="question_title fs-20">Scheduled Study Start</div>
              <div class="enable-disable d-flex justify-content-center" :class="questionnaire.hasRTSMIntegration && 'enable-disable-disabled'">
                <b-form-radio-group class="fs-14 mt-14 mb-0 schedule-feature-radio" id="scheduled-start" v-model="questionnaire.isScheduledStart" :options="studyStartScheduledOptions" :disabled="questionnaire.hasRTSMIntegration" data-testid="scheduled-study-start-radio-group"></b-form-radio-group>
                <b-tooltip :disabled="!questionnaire.hasRTSMIntegration" target="scheduled-start" placement="right" triggers="hover" data-testid="scheduled-start-tooltip">
                  <rtsmTooltipContent />
                </b-tooltip>
              </div>
            </div>
            <div class="form-group mt-33 text-center">
              <button type="button" class="btn btn-md btn-info btn-style col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3 col-xs-6 col-xs-offset-3 br-25" v-on:click="nextQuestion()">
                Continue
              </button>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pb-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="panel panel-default panel-style col-lg-8 col-md-8 col-sm-10 col-xs-10 br-2 " v-if="step === 17">
            <div class="panel-body panel-body-style col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <div class="">
                <div class="question_title">
                  {{ questionsList[step].question }}
                </div>
                <div class="pb-20">Select all that apply.</div>
                <div class="row">
                  <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-sm-offset-2 col-md-offset-2 col-lg-offset-0">
                    <div class="panel panel-default no-border" v-on:click="selectApp('ios')">
                      <div v-if="!questionnaire.ios">
                        <div class="panel-body product-card">
                          <span class="icon-size">
                            <i class="fa fa-apple" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                      <div v-if="questionnaire.ios">
                        <div class="panel-body active-card">
                          <span class="active-icon">
                            <i class="fa fa-apple" aria-hidden="true"></i>
                          </span>
                          <span class="icon_top">
                            <i class="fa fa-check fd" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <h5>iOS App</h5>
                  </div>
                  <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                    <div class="panel panel-default no-border" v-on:click="selectApp('android')">
                      <div v-if="!questionnaire.android">
                        <div class="panel-body product-card">
                          <span class="icon-size">
                            <i class="fa fa-android" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                      <div v-if="questionnaire.android">
                        <div class="panel-body active-card">
                          <span class="active-icon">
                            <i class="fa fa-android" aria-hidden="true"></i>
                          </span>
                          <span class="icon_top">
                            <i class="fa fa-check fd" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <h5>Android App</h5>
                  </div>
                  <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                    <div class="panel panel-default no-border" v-on:click="selectApp('web')">
                      <div v-if="!questionnaire.web">
                        <div class="panel-body product-card">
                          <span class="icon-size">
                            <img class="web-app-img" src="../../../public/static/img/participant-web-img/web-grey-icon.svg" />
                          </span>
                          <!-- <button type="button" class="btn btn-coming-soon">Coming Soon</button> -->
                        </div>
                      </div>
                      <div v-if="questionnaire.web">
                        <div class="panel-body active-card">
                          <span class="active-icon">
                            <!-- <i class="fa fa-desktop" aria-hidden="true"></i> -->
                            <img class="web-app-img" src="../../../public/static/img/participant-web-img/icn-web-app.png" />
                          </span>
                          <span class="icon_top">
                            <i class="fa fa-check fd" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <h5 class="color_666669">Web App</h5>
                  </div>
                  <div v-if="questionnaire.web" class="switch-button pt-20 pb-20 col-md-12">
                    <div class="">
                      <label class="text text-center color_666669">
                        <b>Participant Recruitment Web</b>
                      </label>
                      <label class="switch-toggle-btn">
                        <input type="checkbox" v-model="questionnaire.participantPortal" />
                        <div class="slider"></div>
                        <div class="text"></div>
                      </label>
                    </div>
                    <p>
                      Access to Participant Recruitment Web configurations will only be available when the toggle is enabled.
                    </p>
                  </div>
                </div>
                <div class="pt-20">
                  <button
                    type="button"
                    class="btn btn-md btn-info btn-style col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 br-25"
                    v-on:click="nextQuestion()"
                    :class="{
                      disabledbtn: !questionnaire.android && !questionnaire.ios && !questionnaire.web
                    }"
                    :disabled="(!questionnaire.android && !questionnaire.ios && !questionnaire.web) || disableContinue"
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
            <div class="clearfix fs-12 color_b8c7ce pb-10">
              <span class=" cursor_pointer back_btn" v-on:click="previousQuestion()">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span class="pl-5 fs-14"> Back</span>
              </span>
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 pr-0 pl-40">
            <div class="panel panel-default panel-style side-bar" v-if="step !== 16">
              <div class="panel-body"></div>
            </div>
          </div>
        </transition>
      </div>
      <div class="text-center clearfix pb-20">
        <span v-for="(n, index) in questionsList.filter(question => question.show)" :key="index">
          <span v-if="n.index < step" class="fs-8 p-5 next-icon">
            <i class="fa fa-circle" aria-hidden="true"></i>
          </span>
          <span v-if="n.index === step" class="fs-10 p-5 pl-5 selected-icon">
            <i class="fa fa-circle" aria-hidden="true"></i>
          </span>
          <span v-if="n.index > step" class="fs-8 p-5 next-icon">
            <i class="fa fa-circle-o" aria-hidden="true"></i>
          </span>
        </span>
      </div>
    </div>

    <!-- Cohort Edit Modal -->
    <div class="modal" id="cohortEditModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            Are you sure you want to modify this cohort schedule? This action cannot be undone and all existing participant(s) will reflect the updated cohort configuration.
          </div>
          <!-- Modal footer -->
          <div class="modal-footer">
            <button type="button" class="btn-block fs-14 btn-secondary" variant="secondary" data-dismiss="modal">
              Cancel
            </button>
            <button type="button" class="btn-block fs-14 error-bg switch-warning-yes mt-0 ml-12 btn-primary" data-dismiss="modal" @click="saveEditCohort()">
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import "vue-instant/dist/vue-instant.css";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import toastr from "toastr";
import studyHeader from "../common/study-header";
import swal from "sweetalert2";
import otpInputService from "../services/otp-input-service";
import { v4 as uuidv4 } from "uuid";
import rtsmTooltipContent from "@/components/common/rtsm-tooltip-content.vue";
import { ACTIVE } from "@/constants/config";

export default {
  name: "design",
  data() {
    return {
      tempScreeningMilestoneWindow: [],
      tempMilestoneWindow: [],
      isDisabled: true,
      customStudyType: "",
      cancelCohortName: null,
      swipe: {
        activeIndex: 0
      },
      isContinueBtnDisabled: true,
      value: null,
      studyNameCopy: null,
      validStudyNameValue: false,
      suggestionAttribute: "name",
      suggestions: [],
      studyId: null,
      disabledDates: {},
      disableContinue: false,
      numberValidationFlag: false,
      rangeValidationFlag: false,
      selected: "",
      studySearchedDiseases: [],
      populationIndex: -1,
      studyDiseases: [],
      showUploadFileSection: true,
      applangaAccessToken: null,
      showUploadReadOnlySection: false,
      settingFile: { originalFile: {}, currentFile: {} },
      cohort: null,
      showAddCohortScreen: false,
      showEditCohortScreen: false,
      isMilestoneDisplayCohortCheckboxes: [],
      isScreeningDisplayCohortCheckboxes: [],
      selCohort: null,
      questionnaire: {
        clientId: "default",
        name: null,
        support: null,
        countryList: [],
        targetPatients: [],
        type: "default",
        subType: null,
        expectedPatients: null,
        studyStartDate: "",
        studyEndDate: "",
        firstPatientEnrollDate: "",
        firstPatientLastDate: "",
        lastPatientEnrollDate: "",
        lastPatientLastDate: "",
        startEndDuration: null,
        studyDuration: null,
        lastPatientDuration: null,
        continuousStudy: false,
        isSegmentSupported: false,
        segments: [],
        isMilestoneSupported: true,
        screeningMilestoneAllowed: false,
        milestones: [],
        android: false,
        ios: false,
        web: false,
        description: null,
        language: [],
        studyLanguage: [],
        milestonesList: [],
        screeningMilestoneList: [],
        isManualStudyStart: false,
        isScheduledStart: false,
        rareDisease: null,
        isParticipantIdRequired: false,
        isParticipantIdEditable: true,
        participantPortal: false,
        participantIdFormatConfigured: {
          isFormattingChecked: false,
          size: null,
          format: null,
          isDisallowLetters: false,
          isDisallowNumbers: false,
          isDisallowSpecialCharacters: false,
          colorCodingEnable: false,
          id: null,
          errors: null
        },
        participantIdEnabled: false,
        allowDuplicatePid: false,
        participantIdColorCodingMetaData: [
          {
            colorCodeCharacter: "",
            colorCodeCondition: "None",
            colorCodeConditionValue: "",
            color: "#FF0000",
            active: false
          }
        ],
        hasRTSMIntegration: false
      },
      hasColorConfigError: false,
      colorError: "",
      conditionLogic: [
        { name: "None", value: "None" },
        { name: "Is equal to", value: "Is equal to" },
        { name: "Is not equal to", value: "Is not equal to" }
      ],
      participateIdColorOptions: [
        { name: "red", colorCode: "#FF0000" },
        { name: "green", colorCode: "#008000" },
        { name: "yellow", colorCode: "#FFFF00" },
        { name: "blue", colorCode: "#0000FF" }
      ],
      supportedCountries: [],
      selectedCountries: [],
      linkedLC: {},
      filteredStudyLanguage: [],
      filteredStudyLanguageIds: [],
      defaultLang: null,
      langObjNeedToBeDeleted: { lang: null, index: null },
      selLanguage: null,
      patiantInput: true,
      step: 0,
      questionsList: [
        { index: 0, show: true },
        {
          index: 1,
          question: "Who is the sponsor for this study?",
          clients: [],
          show: true
        },
        { index: 2, question: "What is the name of the study?", show: true },
        {
          index: 3,
          question: "Would you like a THREAD expert to guide you through this process?",
          options: ["Sure, that would help", "No thanks"],
          show: true
        },
        { index: 4, show: true },
        {
          index: 5,
          question: "What countries will this study be conducted in?",
          show: true
        },
        {
          index: 6,
          question: "What languages will the study be conducted in?",
          languages: [],
          show: true
        },
        {
          index: 7,
          question: "For each country, select the languages that will be available in that country",
          show: true
        },
        {
          index: 8,
          question0: "Enter the required information below to automatically translate your study content.",
          question1: "Upload the settings file to automatically translate your study content",
          show: true
        },
        {
          index: 9,
          question: "What is the target participant population(s)?",
          show: true
        },
        {
          index: 10,
          question: "What type of study is this?",
          options: [
            "Class I Device Study",
            "Class II Device Study",
            "Class III Device Study",
            "Diagnostic Study",
            "Feasibility Study",
            "Interventional Study",
            "Observational Study",
            "Participant Community",
            "Pilot Project",
            "Pivotal Study",
            "Phase 0 Clinical Trial",
            "Phase 1 Clinical Trial",
            "Phase 2 Clinical Trial",
            "Phase 2a Clinical Trial",
            "Phase 2b Clinical Trial",
            "Phase 3 Clinical Trial",
            "Phase 3a Clinical Trial",
            "Phase 3b Clinical Trial",
            "Phase 4 Interventional Study",
            "Phase 4 Observational Study",
            "Qualitative Study",
            "Registry",
            "Validation/Burden Study",
            "Other"
          ],
          show: true
        },
        {
          index: 11,
          question: "Will the study participants be invited to enroll in the study (Digital invitation) or can any participant enroll directly by only passing self-reported inclusion/exclusion criteria within the study app (Open enrollment)?",
          type: "button",
          options: [
            { text: "Digital invitation", value: "Digital Invitation" },
            { text: "Open enrollment", value: "Open Enrollment" }
          ],
          show: true
        },
        {
          index: 12,
          question: "What is the number of patients you expect to enroll?",
          show: true
        },
        { index: 13, question: "Configure your Participant ID", show: true },
        { index: 14, question: "What are your key study dates?", show: true },
        { index: 15, question: "Identify study milestones", show: true },
        {
          index: 16,
          question: "Manually Start Study for Participants",
          show: true
        },
        { index: 17, question: "What channels do you need?", show: true }
      ],
      addOption: true,
      showAlert: false,
      showAlertOther: false,
      answer: "",
      activeIcon: '<i class="fa fa-check-circle fd" aria-hidden="true"></i>',
      show: true,
      questionIndices: [],
      feedbackObj: {
        subject: "",
        description: ""
      },
      feedbackSent: false,
      participantTriggerOptions: [
        { text: "Disable", value: false },
        { text: "Enable", value: true }
      ],
      scheduledEdcForms: [],
      unscheduledPacketForms: [],
      studyStartScheduledOptions: [
        { text: "Immediate Start", value: false },
        { text: "Scheduled Start", value: true }
      ],
      isRareDiseaseOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false }
      ],
      isConfigurationDetailSectionEnabled: false,
      formatArray: [],
      participantIdFormatConfiguredInitial: "",
      latinAmericaLanguages: ["Mexico", "Guatemala", "Honduras", "El Salvador", "Nicaragua", "Costa Rica", "Panama", "Colombia", "Venezuela", "Ecuador", "Peru", "Bolivia", "Chile", "French Guiana", "Paraguay", "Brazil", "Argentina", "Uruguay", "Cuba", "The Dominican Republic", "Haiti", "Puerto Rico", "Brazil", "Haiti"],
      displayAddColorCodeBtn: true,
      clientId_DoNot_Delete_Flag: false,
      doNotDeleteStudyFlag: false,
      studyInitialRTSMFlag: false
    };
  },
  computed: {
    filteredStudyDieseases() {
      return this.filterBy(this.studyDiseases, this.selected);
    },
    isContinueButtonDisabled() {
      if (this.questionnaire.targetPatients.length && this.questionnaire.rareDisease !== null) {
        return false;
      } else {
        return true;
      }
    }
  },
  destroyed() {
    document.body.classList.remove("rtsm-custom");
    document.body.classList.remove("rtsm-custom-active");
  },
  watch: {
    selected: {
      handler(val) {
        if (val) {
          window.$(".dropdown").addClass("open");
        }
      }
    },
    "questionnaire.screeningMilestoneAllowed"() {
      this.prepareMilestonesList();
    },
    "questionnaire.isMilestoneSupported"(val) {
      if (val) {
        this.prepareMilestonesList();
      }
    },
    filteredStudyDieseases: {
      handler(val) {
        if (this.selected) {
          this.studySearchedDiseases = [];
          const arr = this.orderBy(val);
          arr.forEach((item, index) => {
            if (index <= 7) {
              this.studySearchedDiseases.push(item);
            }
          });
        }
      }
    },
    step(currentStep) {
      const self = this;
      self.isContinueBtnDisabled = false;
      if (currentStep == 5 && self.studyId && self.studyId != 0) {
        self.isContinueBtnDisabled = true;
        self.$api.getLibraryFeaturesFact(self.studyId).then(() => {
          self.isContinueBtnDisabled = false;
        });
      }
      this.setPointerOnDiseaseInput();

      if (currentStep == 15 && this.questionnaire.screeningOffsetAdded) {
        if (this.questionnaire.screeningMilestoneAllowed) {
          this.filterMilestonesForDisplay();
        }
      }
    },
    "questionnaire.milestonesList": {
      handler(val) {
        this.removeIconInMilestone(val);
      },
      deep: true
    },
    "questionnaire.screeningMilestoneList": {
      handler(val) {
        this.removeIconInMilestone(val);
      },
      deep: true,
      immediate: true
    },
    "questionnaire.isManualStudyStart": {
      handler(val) {
        if (!val) {
          this.questionnaire.isScheduledStart = false;
        }
      },
      deep: true
    }
  },
  components: { studyHeader, otpInputService, datepicker: Datepicker, rtsmTooltipContent },
  async created() {
    try {
      const result = await this.$api.getclientDataDetails();
      const getClientStudyDeleteFlag = result.body.filter(data => {
        return data.featureKey === "DoNotDeleteStudy";
      });
      if (getClientStudyDeleteFlag.length > 0) {
        this.clientId_DoNot_Delete_Flag = getClientStudyDeleteFlag[0].enabled;
      } else {
        this.clientId_DoNot_Delete_Flag = false;
      }
      this.$forceUpdate();
    } catch (error) {
      const errorMsg = error.body && error.body.message ? error.body.message : "Error while getting the client details";
      this.$toastr.error(errorMsg);
    }
  },
  mounted() {
    document.body.classList.add("rtsm-custom");
    this.studyId = this.$route.params.studyId;
    this.questionIndices = _.map(
      _.filter(this.questionsList, o => o.show),
      "index"
    );
    this.getAllClients();
    this.fetchSupportedCountries();
    this.getStudyDiseasesList();
    this.getTranslationFile();
    window.scrollTo(0, 0);
    const d = new Date(this.getExactDayEpoch(new Date()));
    d.setDate(d.getDate() - 1);
    this.disabledDates = { to: d };
    this.step = this.$route.query ? (this.$route.query.step != undefined ? Number(this.$route.query.step) : window.localStorage.getItem("designIndex") ? Number(window.localStorage.getItem("designIndex")) : this.step) : this.step;
    this.fetchSupportedLanguages();
    this.prepareMilestonesList();
    const self = this;
    window.addEventListener("click", e => {
      if (document.getElementsByClassName("colorDropdown")) {
        const colorDropdownElements = document.getElementsByClassName("colorDropdown");
        const testDivs = Array.prototype.filter.call(colorDropdownElements, function(testElement) {
          if (testElement.contains(e.target)) {
            return testElement;
          }
        });
        if (testDivs.length) {
        } else {
          setTimeout(() => {
            self.colorDropdownClose();
          }, 1000);
        }
      } else {
        setTimeout(() => {
          self.colorDropdownClose();
        }, 1000);
      }
    });
  },
  methods: {
    removeIconInMilestone(val) {
      if (val == undefined || null) {
        return;
      }
      val.map((rec, index) => {
        if (index == 0) {
          return;
        }
        rec.showRemoveIcon = true;
      });
    },
    filterMilestonesForDisplay() {
      if (this.questionnaire.screeningMilestoneList.length < 1) {
        this.questionnaire.screeningMilestoneList = this.questionnaire.milestonesList.filter(item => item.milestoneType && item.milestoneType == "screening");
      }

      this.questionnaire.milestonesList.forEach(mile => {
        mile.milestoneDay -= this.questionnaire.screeningDuration;
        mile.milestoneDay = Math.abs(mile.milestoneDay);
      });
      this.questionnaire.screeningOffsetAdded = false;
      this.questionnaire.milestonesList = this.questionnaire.milestonesList.filter(item => !item.milestoneType);
    },
    enableMilestonesForLegacyStudy() {
      if (!this.questionnaire.isMilestoneSupported && this.questionnaire.milestonesList.length > 0) {
        this.questionnaire.isMilestoneSupported = true;
      }
    },
    disabledCohort() {
      this.isDisabled = !(this.cohort.name.length > 0);
    },
    showCheckboxesCohort(index, type) {
      let list;
      if (type == "screening") {
        list = this.isScreeningDisplayCohortCheckboxes;
        for (let i = 0; i < this.isMilestoneDisplayCohortCheckboxes.length; i++) {
          this.isMilestoneDisplayCohortCheckboxes[i] = false;
        }
        this.showList(list, index);
      } else {
        list = this.isMilestoneDisplayCohortCheckboxes;
        for (let i = 0; i < this.isScreeningDisplayCohortCheckboxes.length; i++) {
          this.isScreeningDisplayCohortCheckboxes[i] = false;
        }
        this.showList(list, index);
      }
      this.$forceUpdate();
    },
    showList(list, index) {
      for (let i = 0; i < list.length; i++) {
        if (i === index) {
          list[index] = !list[index];
        } else {
          list[i] = false;
        }
      }
    },
    setPointerOnDiseaseInput() {
      setTimeout(() => {
        const input = window.document.getElementById("diseaseDropdown");
        if (input) {
          input.click();
        }
      }, 500);
    },
    numberValidation() {
      const number = parseInt(this.questionnaire.expectedPatients);
      this.numberValidationFlag = isNaN(number) || !Number.isInteger(number) || this.questionnaire.expectedPatients !== number.toString();
      this.rangeValidationFlag = !this.numberValidationFlag && (number < 1 || number > 999999);
    },
    updateForcedLanguage() {
      this.$forceUpdate();
    },
    prepareMilestonesList() {
      if (this.questionnaire.screeningMilestoneAllowed) {
        if ((this.questionnaire.screeningMilestoneList && this.questionnaire.screeningMilestoneList.length == 0) || this.questionnaire.screeningMilestoneList == undefined) {
          this.questionnaire.screeningMilestoneList = new Array(1).fill(null).map(() => {
            return {
              sortOrder: 0,
              milestoneName: null,
              milestoneDay: null,
              durationMinus: null,
              durationPlus: null,
              displayName: null,
              showRemoveIcon: false,
              milestoneType: "screening",
              cohorts: []
            };
          });
        }
        this.prepareCohortCheckboxes(this.questionnaire.screeningMilestoneList, "screening");
        if (this.studyId && this.studyId != "0") {
          this.questionnaire.screeningOffsetAdded = true;
        }
      }

      if (this.questionnaire.milestonesList.length == 0 || this.questionnaire.milestonesList == undefined) {
        this.questionnaire.milestonesList = new Array(6).fill(null).map(() => {
          return {
            sortOrder: 0,
            milestoneName: null,
            milestoneDay: null,
            durationMinus: null,
            durationPlus: null,
            displayName: null,
            showRemoveIcon: false,
            milestoneType: null,
            segments: []
          };
        });

        this.prepareCohortCheckboxes(this.questionnaire.milestonesList, null);
      }
    },
    prepareCohortCheckboxes(milestones, type) {
      let cohortList;
      if (type == "screening") {
        cohortList = this.isScreeningDisplayCohortCheckboxes;
      } else {
        cohortList = this.isMilestoneDisplayCohortCheckboxes;
      }
      if (milestones) {
        for (let i = 0; i < milestones.length; i++) {
          cohortList[i] = false;
        }
      }
    },
    checkForAccessToken() {
      if (this.applangaAccessToken == null || this.applangaAccessToken == "") {
        return;
      }
      if (this.applangaAccessToken.indexOf("!") == -1) {
        toastr.error("Invalid applanga access token");
        return;
      }
      this.showUploadReadOnlySection = !!(this.applangaAccessToken && this.settingFile.currentFile.file);
      this.showUploadFileSection = !(this.applangaAccessToken && this.settingFile.currentFile.file);
    },
    makeDefaultCountryDisabled(countries) {
      countries.map((c, index) => {
        if (c.isoCode3 == "USA") {
          c.isDisabled = true;
          this.selectedCountries.push(c);
          countries.splice(0, 0, c);
          countries.splice(index + 1, 1);
        } else {
          c.isDisabled = false;
        }
      });
      return countries;
    },
    fetchSupportedCountries() {
      this.$api.getSupportedCountries().then(
        response => {
          if (response.body.length == 0) {
            return;
          }
          this.supportedCountries = this.makeDefaultCountryDisabled(response.body);
          //pre-selecting the country if only one country in the response and it's china(pg.platform)
          this.preselectCountry(this.supportedCountries);
          this.getStudyDetails();
        },
        () => {
          toastr.error("Error occurred while featching Countries.");
        }
      );
    },
    preselectCountry(countries) {
      if (this.studyId == "0" && countries.length == 1) {
        if (countries[0].isoCode3 == "CHN") {
          this.selectedCountries.push(countries[0]);
        }
      }
    },
    fetchSupportedLanguages() {
      const self = this;
      this.$api.getSupportedClientLanguages().then(
        response => {
          if (response.body.length == 0) {
            return;
          }
          const languageSortOrderSequence = _.orderBy(response.body, "name", "asc");
          languageSortOrderSequence.forEach(lang => {
            // predefined index if in any case index change please also update this too.
            self.questionsList[6].languages.push(lang);
            // select english as defulat language
            if (self.studyId == 0) {
              if (lang.name.toLowerCase() == "english") {
                self.questionnaire.language.push(_.cloneDeep(lang));
                self.questionnaire.studyLanguage.push(lang);
                this.$set(this.questionnaire.studyLanguage[0], "draft", false); // English language is live for new study
              }
            }
          });
        },
        () => {
          toastr.error("Error occurred while featching languages.");
        }
      );
    },
    getTranslationFile() {
      if (this.studyId == "0") {
        this.showUploadReadOnlySection = true;
        return;
      }
      const self = this;
      this.$api.getTranslationFile(this.studyId).then(response => {
        if (response.body.appPropertiesDocument == null) {
          this.showUploadFileSection = true;
          this.showUploadReadOnlySection = false;
          return;
        }
        self.settingFile.originalFile.name = "applanga_settings.applanga";
        self.settingFile.originalFile.displayName = "applanga_settings.applanga";
        self.settingFile.originalFile.s3Location = response.body.appPropertiesDocument.s3Location;
        self.settingFile.originalFile.documentURL = response.body.appPropertiesDocument.documentURL;
        self.settingFile.originalFile.documentId = response.body.appPropertiesDocument.documentId;
        self.settingFile.currentFile = { ...self.settingFile.originalFile };
        self.showUploadFileSection = false;
        self.showUploadReadOnlySection = true;
      });
    },
    getExactDayEpoch(day) {
      day = new Date(day); // eslint-disable-line
      return Date.UTC(day.getFullYear(), day.getMonth(), day.getDate());
    },
    getFormattedDate(timestamp) {
      const ISOStringFormat = new Date(timestamp).toISOString();
      const formattedDate = moment(ISOStringFormat)
        .utc()
        .format("MM/DD/YYYY");
      return moment(formattedDate, "MM/DD/YYYY", true).isValid() ? formattedDate : ISOStringFormat;
    },
    validStudyName(studyNameVal) {
      const studyPattern = new RegExp("^[a-zA-Z]{1}[ a-zA-Z0-9®!@#$%^&{}*)(+=.?_-]{0,48}[a-zA-Z0-9®!@#$%^&{}*)(+=.?_-]{1}$");
      if (studyPattern.test(studyNameVal)) {
        this.validStudyNameValue = false;
      } else {
        this.validStudyNameValue = true;
      }
    },
    navigateDisease(e) {
      if (this.studySearchedDiseases.length === 0 && e.keyCode === 13) {
        this.selectedPatientPopulations(this.selected);
      } else {
        if (this.populationIndex < this.studySearchedDiseases.length - 1) {
          if (e.keyCode === 38) {
            if (this.populationIndex !== 0) {
              this.populationIndex -= 1;
            } else {
              this.populationIndex = 0;
            }
          } else if (e.keyCode === 40) {
            this.populationIndex += 1;
          }
          if (e.keyCode === 40) {
            this.populationIndex += 1;
          }
        } else if (e.keyCode === 38) {
          this.populationIndex -= 1;
        }
        if (e.keyCode === 13) {
          this.selected = "";
          this.selectedPatientPopulations(this.studySearchedDiseases[this.populationIndex]);
        }
      }
    },
    totalActiveLanguage() {
      const languageList = this.questionnaire.language.filter(lang => {
        return lang.active == true;
      });
      return languageList.length == 1;
    },
    getStudyDetails() {
      if ((this.studyId && this.studyId !== "0") || this.studyNameCopy !== this.questionnaire.name) {
        this.$api.getStudyDataFact(this.studyId).then(
          response => {
            this.questionnaire = response.body;
            this.studyInitialRTSMFlag = response.body.hasRTSMIntegration;

            if (this.isStudyActive()) {
              document.body.classList.add("rtsm-custom-active");
            }

            //Check if there is screening milestone
            if (this.questionnaire.screeningMilestoneAllowed) {
              this.questionnaire.screeningMilestoneList = this.questionnaire.milestonesList.filter(mile => mile.milestoneType && mile.milestoneType == "screening");
            }

            if (this.questionnaire.screeningMilestoneAllowed) {
              this.prepareCohortCheckboxes(this.questionnaire.screeningMilestoneList, "screening");
            }
            this.prepareCohortCheckboxes(this.questionnaire.milestonesList, null);

            this.enableMilestonesForLegacyStudy();
            this.participantIdFormatConfiguredInitial = response.body.participantIdFormatConfigured.format;
            this.format = response.body.participantIdFormatConfigured.format;
            this.studyNameCopy = this.questionnaire.name ? _.cloneDeep(this.questionnaire.name) : null;
            this.addOption = false;
            if (this.questionnaire.studyStartDate) {
              this.questionnaire.studyStartDate = this.getFormattedDate(this.questionnaire.studyStartDate); // eslint-disable-line
              this.questionnaire.studyEndDate = this.getFormattedDate(this.questionnaire.studyEndDate); // eslint-disable-line
              this.questionnaire.firstPatientEnrollDate = this.getFormattedDate(this.questionnaire.firstPatientEnrollDate); // eslint-disable-line
              this.questionnaire.firstPatientLastDate = this.getFormattedDate(this.questionnaire.firstPatientLastDate); // eslint-disable-line
              this.questionnaire.lastPatientEnrollDate = this.questionnaire.lastPatientEnrollDate ? this.getFormattedDate(this.questionnaire.lastPatientEnrollDate) : ""; // eslint-disable-line
              this.questionnaire.lastPatientLastDate = this.questionnaire.lastPatientLastDate ? this.getFormattedDate(this.questionnaire.lastPatientLastDate) : ""; // eslint-disable-line
            }
            // Handling other case while updating study
            if (this.questionsList["10"].options.indexOf(this.questionnaire.type) == -1) {
              this.customStudyType = this.questionnaire.type.trim();
              this.questionnaire.type = "Other";
            } else if (this.questionnaire.type == "Other") {
              this.customStudyType = this.questionnaire.type.trim();
            }

            this.supportedCountries.map(c => {
              response.body.countryList.map(saveCountry => {
                if (saveCountry.isoCode3 == c.isoCode3 && saveCountry.isoCode3 != "USA") {
                  this.selectedCountries.push(c);
                }
              });
            });
            this.questionnaire.language = response.body.language;
            this.questionnaire.studyLanguage = response.body.studyLanguage;
            this.showUploadReadOnlySection = !!(this.questionnaire.language && this.questionnaire.language.length > 1);
            let defaultLang = null;
            const langs = this.questionnaire.language;
            const langsDto = this.questionnaire.studyLanguage;
            for (let i = langs.length - 1; i > -1; i--) {
              const langDraft = langsDto[i].draft != null ? langsDto[i].draft : true;
              this.$set(this.questionnaire.studyLanguage[i], "draft", langDraft);
              if (langs[i].language_culture == "EN" && i != 0) {
                defaultLang = langs[i];
                this.questionnaire.language.splice(i, 1);
                this.questionnaire.studyLanguage.splice(i, 1);
              }
            }
            this.questionnaire.language = _.orderBy(this.questionnaire.language, "name");
            this.questionnaire.studyLanguage = _.orderBy(this.questionnaire.studyLanguage, "name");
            if (defaultLang != null) {
              this.questionnaire.language.splice(0, 0, _.cloneDeep(defaultLang));
              this.questionnaire.studyLanguage.splice(0, 0, defaultLang);
              // English is live for every case
              this.$set(this.questionnaire.studyLanguage[0], "draft", false);
              this.defaultLang = defaultLang;
            }
            this.questionnaire.participantIdFormatConfigured.colorCodingEnable = response.body.participantIdFormatConfigured.colorCodingEnable;
            this.questionnaire.participantIdColorCodingMetaData = this.questionnaire.participantIdColorCodingMetaData;
            this.linkedLC = response.body.linkedCountryLanguages ? response.body.linkedCountryLanguages : {};
            if (this.questionnaire.participantIdFormatConfigured.format) {
              const format = JSON.parse(this.questionnaire.participantIdFormatConfigured.format);
              this.formatArray.push(format);
            }
            if (this.questionnaire.participantIdFormatConfigured.isFormattingChecked) {
              this.isConfigurationDetailSectionEnabled = true;
            }
            if (!!this.questionnaire.participantIdColorCodingMetaData && this.questionnaire.participantIdColorCodingMetaData.length > 0) {
              this.questionnaire.participantIdColorCodingMetaData.filter(data => {
                data["active"] = false;
              });
            }
            this.calculateStartEndDuration(this.questionnaire);
            this.calculateLatPatientDuration(this.questionnaire);
            this.getFormsForMilestone();
            this.doNotDeleteStudyFlag = this.questionnaire.doNotDelete;
          },
          error => {
            toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the study details");
          }
        );
      }
    },
    setcohorts(cohart) {
      let countValue = 0;
      if (this.questionnaire && this.questionnaire.milestonesList.length > 0) {
        this.questionnaire.milestonesList.forEach(milestone => {
          if (milestone.segments && milestone.segments.length > 0) {
            milestone.segments.findIndex(val => val == cohart.id) > -1 ? countValue++ : "";
          }
        });
        if (this.questionnaire.screeningMilestoneAllowed && this.questionnaire.screeningMilestoneList) {
          this.questionnaire.screeningMilestoneList.forEach(milestone => {
            if (milestone.segments && milestone.segments.length > 0) {
              milestone.segments.findIndex(val => val == cohart.id) > -1 ? countValue++ : "";
            }
          });
        }

        return countValue;
      }
    },
    getStudyDiseasesList() {
      this.$api.getStudyDiseasesFact().then(
        response => {
          response.body.forEach(item => {
            this.studyDiseases.push(item.name);
          });
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the study details");
        }
      );
    },
    studyContinuousChanged(val) {
      this.questionnaire.lastPatientEnrollDate = "";
      this.questionnaire.lastPatientLastDate = "";
      this.questionnaire.continuousStudy = val;
    },
    dontSetupMilestones() {
      //If there are milestones scheduled in any activies do not allow removing milestones
      if (this.questionnaire.canMilestonesModifyList && this.questionnaire.canMilestonesModifyList.length > 0) {
        toastr.error("You have scheduled activities and/or notifications associated with milestone(s). Please remove them first before deleting the milestone(s).");
        return;
      }
      this.questionnaire.milestonesList = [];
      this.questionnaire.screeningMilestoneList = [];
      this.step = this.step + 1;
    },
    createNewStudy(studyData) {
      const newStudyData = { ...studyData };
      this.disableContinue = true;
      newStudyData.studyStartDate = new Date(this.getExactDayEpoch(newStudyData.studyStartDate)).toUTCString();
      newStudyData.studyEndDate = new Date(this.getExactDayEpoch(newStudyData.studyEndDate)).toUTCString();
      newStudyData.firstPatientEnrollDate = new Date(this.getExactDayEpoch(newStudyData.firstPatientEnrollDate)).toUTCString();
      newStudyData.firstPatientLastDate = new Date(this.getExactDayEpoch(newStudyData.firstPatientLastDate)).toUTCString();
      newStudyData.lastPatientEnrollDate = newStudyData.lastPatientEnrollDate ? new Date(this.getExactDayEpoch(newStudyData.lastPatientEnrollDate)).toUTCString() : "";
      newStudyData.lastPatientLastDate = newStudyData.lastPatientLastDate ? new Date(this.getExactDayEpoch(newStudyData.lastPatientLastDate)).toUTCString() : "";
      newStudyData.countries = [{ name: "United States of America", language: "US English" }];
      newStudyData.milestones = [];
      newStudyData.milestonesList.map((mile, index) => {
        newStudyData.milestones[index] = mile.milestoneDay;
      });
      for (let i = 0; i < this.questionnaire.countryList.length; i++) {
        let flag = true;
        for (let j = 0; j < this.selectedCountries.length; j++) {
          if (this.selectedCountries[j].countryId == this.questionnaire.countryList[i].countryId) {
            flag = false;
            continue;
          }
        }
        if (flag) {
          this.questionnaire.countryList[i].active = false;
          this.selectedCountries.push(this.questionnaire.countryList[i]);
        }
      }
      newStudyData.countryList = this.selectedCountries;
      newStudyData.linkedCountryLanguages = this.linkedLC;
      newStudyData.rareDisease = this.questionnaire.rareDisease;
      if (newStudyData.type == "Other") {
        newStudyData.type = this.customStudyType.trim();
      }
      this.questionnaire.milestonesList.map(milestoneObj => {
        delete milestoneObj.readonly;
      });
      newStudyData.doNotDelete = this.doNotDeleteStudyFlag;
      const self = this;
      this.$api.postNewStudyDataFact(newStudyData).then(
        response => {
          if (this.studyInitialRTSMFlag && !newStudyData.hasRTSMIntegration) {
            this.removeRTSMIntegration();
          }

          if (response.body.web === true && response.body.android === false && response.body.ios === false) {
            this.$router.push({
              name: "dashboard",
              params: { studyId: response.body.studyId }
            });
            return;
          } else {
            window.localStorage.removeItem("designIndex");
            self.studyId = response.body.studyId;
            if (newStudyData.language.length <= 1 || self.settingFile.currentFile.file == null) {
              this.$router.push({
                name: "study-build-progress",
                params: { studyId: response.body.studyId }
              });
              return;
            }
            // upload file if needed.
            const fileObj = self.settingFile.currentFile.file ? self.settingFile.currentFile.file : self.settingFile.originalFile.file;
            const documentId = self.settingFile.currentFile.documentId ? self.settingFile.currentFile.documentId : self.settingFile.originalFile.documentId;
            const fd = new FormData();
            fd.append("fileName", fileObj);
            fd.append("applangaAccessToken", self.applangaAccessToken);
            fd.append("isActive", !self.totalActiveLanguage());
            this.$api.updateSettingsFile(this.studyId, fd, documentId).then(
              () => {
                this.$router.push({
                  name: "study-build-progress",
                  params: { studyId: self.studyId }
                });
              },
              error => {
                toastr.error(error.body ? error.body.message : "Error while uploading the transaltion file");
              }
            );
          }
          // upload file section done
        },
        error => {
          this.disableContinue = false;
          toastr.error(error.body && error.body.message ? error.body.message : "Error while creating new study");
        }
      );
    },
    getAllClients() {
      this.$api.getAllClientsFact().then(response => {
        this.questionsList[1].clients = response.body;
      });
    },
    calculateNextOrPrevStep(order) {
      this.settingFile.currentFile.displayName = this.settingFile.currentFile.displayName ? this.settingFile.currentFile.displayName : this.settingFile.currentFile.name;
      this.showUploadFileSection = !this.settingFile.currentFile.displayName;
      this.showUploadReadOnlySection = !!this.settingFile.currentFile.displayName;
      const step = order == "increment" ? (this.totalActiveLanguage() == 1 ? this.step + 2 : this.step) : this.totalActiveLanguage() == 1 ? this.step - 2 : this.step;
      return step;
    },
    nextQuestion() {
      let sd;
      let ed;
      let fpfd;
      let fpld;
      let lpfd;
      let lpld;
      switch (this.step) {
        case 2:
          if (!this.studyId || this.studyId === "0" || this.studyNameCopy !== this.questionnaire.name) {
            this.$api
              .checkNewStudyNameValidityFact({
                studyName: this.questionnaire.name
              })
              .then(
                () => {
                  this.step = this.getStepNumber(this.step);
                },
                error => {
                  toastr.error(error.body ? error.body.message : "Error while checking the study name validity");
                }
              );
          } else {
            this.step = this.getStepNumber(this.step);
          }
          break;
        case 4:
          if (this.questionnaire.countryList.length > 0) {
            this.addOption = false;
          }
          this.step = this.getStepNumber(this.step);
          break;
        case 6:
          if (this.questionnaire.targetPatients.length > 0) {
            this.addOption = false;
          } else {
            this.addOption = true;
          }

          this.step = this.calculateNextOrPrevStep("increment");
          this.step = this.getStepNumber(this.step);
          this.removedLinkedCountry();
          this.addLinkedLanguages();
          break;
        case 7:
          for (const singleCountry of this.selectedCountries) {
            if (this.linkedLC[singleCountry.countryId].length == 0) {
              this.$toastr.error("Please select at least one language for " + singleCountry.countryName);
              return;
            }
          }
          this.step = this.getStepNumber(this.step);
          break;
        case 10:
          if (["Phase 2 Clinical Trial", "Phase 3 Clinical Trial"].indexOf(this.questionnaire.type) >= 0) {
            this.questionnaire.subType = this.questionsList[11].options[0];
            this.step = this.getStepNumber(this.step);
          }
          this.step = this.getStepNumber(this.step);
          this.selected = "";
          break;
        case 11:
          if (this.questionnaire.hasRTSMIntegration) {
            this.questionnaire.isParticipantIdRequired = false;
            this.questionnaire.isParticipantIdEditable = false;
            this.questionnaire.participantIdFormatConfigured.isFormattingChecked = false;
            this.questionnaire.allowDuplicatePid = false;
            this.questionnaire.isManualStudyStart = true;
            this.questionnaire.isScheduledStart = false;

            if (this.isConfigurationDetailSectionEnabled) {
              this.resetParticipantIdFormatConfigured(true);
            }
          }

          this.step = this.getStepNumber(this.step);
          break;
        case 12:
          this.step = this.getStepNumber(this.step);
          break;
        case 13:
          // if formatting is true then apply validation

          if (this.questionnaire.participantIdFormatConfigured.isFormattingChecked) {
            if (this.questionnaire.participantIdFormatConfigured.size == null || this.questionnaire.participantIdFormatConfigured.size == "" || this.questionnaire.participantIdFormatConfigured.size == 0) {
              this.questionnaire.participantIdFormatConfigured.errors = "Please specify the maximum number of characters";
              this.$forceUpdate();
              return;
            }
            if (isNaN(this.questionnaire.participantIdFormatConfigured.size)) {
              this.questionnaire.participantIdFormatConfigured.errors = "Numeric entries only";
              this.$forceUpdate();
              return;
            } else if (Number(this.questionnaire.participantIdFormatConfigured.size) > 99) {
              this.questionnaire.participantIdFormatConfigured.errors = "Max number of characters cannot exceed 99";
              this.$forceUpdate();
              return;
            } else if (Math.sign(this.questionnaire.participantIdFormatConfigured.size) < 0) {
              this.questionnaire.participantIdFormatConfigured.errors = "Negative values are not allowed";
              this.$forceUpdate();
              return;
            }
            if (this.questionnaire.participantIdFormatConfigured.isDisallowLetters && this.questionnaire.participantIdFormatConfigured.isDisallowNumbers && this.questionnaire.participantIdFormatConfigured.isDisallowSpecialCharacters) {
              this.$toastr.warning("Checking all the boxes restricts all possible characters. Please revise your selection.");
              return;
            }
            const sizeOfPid = this.questionnaire.participantIdFormatConfigured.size;
            const arrLenght = this.questionnaire.participantIdColorCodingMetaData.length;
            if (sizeOfPid < arrLenght) {
              this.$toastr.error("Please revise your color code combination as per configured PID.");
              return;
            }
            if (this.questionnaire.participantIdColorCodingMetaData.length > 0) {
              for (const item of this.questionnaire.participantIdColorCodingMetaData) {
                if (item.colorCodeCondition != "None") {
                  if (this.questionnaire.participantIdFormatConfigured.isDisallowLetters && /[a-zA-Z]/g.test(item.colorCodeConditionValue)) {
                    toastr.error("Letters are not allowed.");
                    return;
                  } else if (this.questionnaire.participantIdFormatConfigured.isDisallowNumbers && /[0-9]/g.test(item.colorCodeConditionValue)) {
                    toastr.error("Numbers are not allowed.");
                    return;
                  } else if (this.questionnaire.participantIdFormatConfigured.isDisallowSpecialCharacters && /[[\];=!@#$%^&*(),.?":{}|<>+~/`-]/g.test(item.colorCodeConditionValue)) {
                    toastr.error("Special characters are not allowed.");
                    return;
                  } else if (item.errorChar) {
                    return;
                  }
                } else if (item.errorChar) {
                  return;
                }
              }
            }
            this.questionnaire.participantIdFormatConfigured.errors = null;
            this.questionnaire.participantIdFormatConfigured.format = JSON.stringify(this.formatArray[this.formatArray.length - 1]);
            if (this.questionnaire.participantIdFormatConfigured.format == undefined) {
              this.questionnaire.participantIdFormatConfigured.format = this.participantIdFormatConfiguredInitial;
            }
          } else {
            this.questionnaire.participantIdFormatConfigured.size = null;
            this.questionnaire.participantIdFormatConfigured.format = null;
            this.questionnaire.participantIdFormatConfigured.isDisallowLetters = false;
            this.questionnaire.participantIdFormatConfigured.isDisallowNumbers = false;
            this.questionnaire.participantIdFormatConfigured.isDisallowSpecialCharacters = false;
            this.questionnaire.participantIdFormatConfigured.errors = null;
          }
          if (this.questionnaire.participantIdFormatConfigured.colorCodingEnable && this.questionnaire.participantIdColorCodingMetaData.length == 0) {
            this.$toastr.error("Please set up at least one color-coded character.");
            return;
          } else if (this.questionnaire.participantIdFormatConfigured.colorCodingEnable && this.questionnaire.participantIdColorCodingMetaData.length) {
            for (let i = 0; i <= this.questionnaire.participantIdColorCodingMetaData.length - 1; i++) {
              if (
                (this.questionnaire.participantIdColorCodingMetaData.length && this.questionnaire.participantIdColorCodingMetaData[i].colorCodeCharacter == "") ||
                ((this.questionnaire.participantIdColorCodingMetaData[i].colorCodeCondition == "Is equal to" || this.questionnaire.participantIdColorCodingMetaData[i].colorCodeCondition == "Is not equal to") && this.questionnaire.participantIdColorCodingMetaData[i].colorCodeConditionValue == "")
              ) {
                this.$toastr.error("Please set up at least one color-coded character.");
                return;
              }
            }
          }
          this.step = this.getStepNumber(this.step);
          break;
        case 14:
          sd = this.getExactDayEpoch(this.questionnaire.studyStartDate);
          ed = this.getExactDayEpoch(this.questionnaire.studyEndDate);
          fpfd = this.getExactDayEpoch(this.questionnaire.firstPatientEnrollDate);
          fpld = this.getExactDayEpoch(this.questionnaire.firstPatientLastDate);
          lpfd = this.getExactDayEpoch(this.questionnaire.lastPatientEnrollDate);
          lpld = this.getExactDayEpoch(this.questionnaire.lastPatientLastDate);
          if ((this.questionnaire.continuousStudy && sd <= fpfd && fpfd < fpld && fpld <= ed) || (!this.questionnaire.continuousStudy && sd <= fpfd && fpfd < fpld && fpld < ed && sd < lpfd && fpfd < lpfd && lpfd < lpld && lpld <= ed)) {
            this.step = this.getStepNumber(this.step);
            this.addOption = true;
            this.selected = "";
          } else if (!this.questionnaire.continuousStudy) {
            if (sd > fpfd) {
              toastr.error("First patient first date cannot be prior to start date.");
            } else if (fpfd > fpld) {
              toastr.error("First patient last day cannot be prior to first patient first day.");
            } else if (fpfd >= lpfd || lpfd >= fpld) {
              toastr.error("Last patient first day should be between first patient first day and first patient last date");
            } else if (sd > fpfd || fpfd > fpld || fpld >= ed || lpld > ed) {
              toastr.error("Enrollment and participation in the Study must be scheduled within its duration.");
            } else if (lpfd > lpld) {
              toastr.error("Last patient last day should be greater than last patient first day.");
            } else if (lpfd === lpld) {
              toastr.error("Last patient first day cannot be the same as last patient last day.");
            } else if (fpfd === fpld) {
              toastr.error("First patient first day cannot be the same as first patient last day.");
            }
          } else if (this.questionnaire.continuousStudy) {
            if (sd > fpfd) {
              toastr.error("First patient first date cannot be prior to start date.");
            } else if (fpfd > fpld) {
              toastr.error("First patient last day cannot be prior to first patient first day.");
            } else if (sd > fpfd || fpfd > fpld || fpld > ed) {
              toastr.error("Enrollment and participation in the Study must be scheduled within its duration.");
            } else if (fpfd === fpld) {
              toastr.error("First patient first day cannot be the same as first patient last day.");
            }
          }
          break;
        case 15:
          if (this.questionnaire.screeningMilestoneAllowed && this.questionnaire.screeningMilestoneList.length > 0) {
            const screeningList = this.questionnaire.screeningMilestoneList;
            const screeningDuration = this.questionnaire.screeningDuration;
            const screeningMilestoneValidated = this.validateMilestones("screening", screeningList, screeningDuration, this.questionnaire.continuousStudy);
            if (!screeningMilestoneValidated) {
              return;
            } else {
              this.questionnaire.screeningMilestoneList = screeningMilestoneValidated;
            }
          }

          const milestoneList = this.questionnaire.milestonesList;
          const studyDuration = this.questionnaire.studyDuration;
          const milestoneValidated = this.validateMilestones("", milestoneList, studyDuration, this.questionnaire.continuousStudy);
          // Validation for Screening milestone and Non screening milestone if both overlap
          if (this.tempScreeningMilestoneWindow.length > 0 && this.tempMilestoneWindow.length > 0) {
            for (let y = 0; y < this.tempMilestoneWindow.length; y++) {
              const currBeginTemp = this.tempMilestoneWindow[y].startRange;
              const currEndTemp = this.tempMilestoneWindow[y].endRange;
              for (let x = 0; x < this.tempScreeningMilestoneWindow.length; x++) {
                const innerBeginTemp = this.tempScreeningMilestoneWindow[x].startRangeScreening;
                const innerEndTemp = this.tempScreeningMilestoneWindow[x].endRangeScreening;
                if ((currBeginTemp >= innerBeginTemp && currBeginTemp <= innerEndTemp) || (currEndTemp >= innerBeginTemp && currEndTemp <= innerEndTemp)) {
                  toastr.error(`Screening Milestone days are overlapping.`);
                  return false;
                }
              }
            }
          }
          if (milestoneValidated) {
            if (this.questionnaire.screeningMilestoneAllowed && this.questionnaire.screeningMilestoneList.length > 0) {
              //Adding screening duration to regular milestone
              this.questionnaire.milestonesList.forEach(mile => {
                mile.milestoneDay += this.questionnaire.screeningDuration;
              });

              //Adding screening duration to screening milestone
              this.questionnaire.screeningMilestoneList.forEach(mile => {
                mile.milestoneDay = -mile.milestoneDay;
                mile.milestoneDay += this.questionnaire.screeningDuration;
              });
              this.questionnaire.screeningOffsetAdded = true;
              this.questionnaire.milestonesList = [...milestoneValidated, ...this.questionnaire.screeningMilestoneList];
            } else {
              this.questionnaire.milestonesList = milestoneValidated;
            }

            // refresh the all milestone details
            this.questionnaire.milestonesList.map((rec, index) => {
              rec.milestoneName = rec.milestoneName == null || rec.milestoneName == "" ? "Milestone " + (index + 1) : rec.milestoneName;
              rec.sortOrder = index;
              rec.displayName = rec.milestoneName;
              rec.readonly = true;
            });

            this.step = this.getStepNumber(this.step);
          } else {
            return;
          }
          break;
        case 17:
          //Clearing milestone on submit if the milestone toggle is off
          if (!this.questionnaire.isMilestoneSupported && this.questionnaire.milestonesList.length > 0) {
            this.questionnaire.milestonesList = [];
            this.questionnaire.milestonesIds = [];
          }

          this.createNewStudy(this.questionnaire);
          break;
        default:
          this.step = this.getStepNumber(this.step);
          if (!this.studyId) {
            this.addOption = true;
            this.selected = "";
          }
          break;
      }
    },
    validateMilestones(type, list, duration, continuousStudy) {
      let milestoneText;
      if (type && type == "screening") {
        milestoneText = "Screening Milestone";
        if (!duration) {
          toastr.error(`Please Enter ${milestoneText} Duration`);
          return;
        }
      } else {
        milestoneText = "Milestone";
      }

      const milestoneArr = list.filter(milestone => {
        return (milestone.milestoneDay != null && milestone.milestoneDay != "") || milestone.milestoneDay === 0;
      });

      const allFieldsFilled = milestoneArr.filter(milestone => {
        return milestone.milestoneDay == null;
      });

      if (allFieldsFilled.length > 0) {
        toastr.error(`Please fill complete ${milestoneText} details`);
        return;
      }

      if (type == "screening" && (duration % 1 !== 0 || duration < 0)) {
        toastr.error(`Screening duration should start from 0 and cannot have decimals.`);
        return;
      }

      if (milestoneArr.length > 0) {
        const milestoneDays = _.map(milestoneArr, "milestoneDay");
        const milestoneName = _.map(milestoneArr, "milestoneName");
        const hasNegativeValues = milestoneDays.filter(rec => {
          return rec && (rec % 1 !== 0 || rec < 0);
        });

        if (hasNegativeValues.length > 0) {
          toastr.error(`${milestoneText}s values should start from 0 and cannot have decimals.`);
          return;
        }

        if (type == "screening") {
          const zeroDay = milestoneArr.filter(mile => mile.milestoneDay == 0);
          if (zeroDay.length > 0) {
            toastr.error(`${milestoneText}s cannot have 0 Day.`);
            return;
          }
        }

        if (_.uniq(milestoneDays).length !== milestoneArr.length) {
          toastr.error(`${milestoneText}s cannot have the same value.`);
          return;
        }

        // milestone name should have max 18 char
        if (milestoneName) {
          const names = milestoneName.filter(name => {
            return name != null && name != "";
          });
          if (_.uniq(names).length !== names.length) {
            toastr.error(`${milestoneText}s cannot have the same name.`);
            return;
          }
          const isExceedMaxChar = names.filter(name => {
            return name != null && name != "" && name.length > 18;
          });
          if (isExceedMaxChar.length > 0) {
            toastr.error(`${milestoneText} name must be no longer than 18 characters.`);
            return;
          }
        }

        if (duration < _.max(milestoneDays)) {
          toastr.error(`This ${milestoneText} is outside of study's duration.`);
          return;
        }

        //validations for Duration + & Duration -
        if (milestoneArr) {
          let milestoneList = milestoneArr;
          let milestoneListWindow = [];
          let milestoneListWindowScreening = [];

          for (let i = 0; i < milestoneList.length; i++) {
            const milestoneDay = milestoneList[i].milestoneDay;
            const milestoneMinusDay = milestoneList[i] && milestoneList[i].durationMinus ? milestoneList[i].durationMinus : 0;
            const milestonePlusDay = milestoneList[i] && milestoneList[i].durationPlus ? milestoneList[i].durationPlus : 0;
            if (type != "screening") {
              let startRange = milestoneDay - milestoneMinusDay;
              let endRange = milestoneDay + milestonePlusDay;
              milestoneListWindow[i] = { startRange, endRange };
            }
            if (type == "screening") {
              // Screening window calculation
              let startRangeScreening = -1 * (milestoneDay + milestoneMinusDay);
              let endRangeScreening = milestoneDay - milestonePlusDay;
              endRangeScreening = endRangeScreening === 0 ? 0 : -1 * endRangeScreening;
              milestoneListWindowScreening[i] = { startRangeScreening, endRangeScreening };
            }
            if ((milestoneMinusDay && (milestoneMinusDay % 1 !== 0 || milestoneMinusDay < 0)) || (milestonePlusDay && (milestonePlusDay % 1 !== 0 || milestonePlusDay < 0))) {
              toastr.error(`${milestoneText}s values should start from 0 and cannot have decimals.`);
              return;
            }

            //should be after start day
            if (i == 0 && milestoneMinusDay > milestoneDay) {
              toastr.error(`${milestoneText} is outside of study's duration.`);
              return;
            }

            //Skip this if the study is continuous
            if (!continuousStudy && duration < milestoneDay + milestonePlusDay) {
              toastr.error(`${milestoneText} is outside of study's duration.`);
              return;
            }
          }

          if (type == "screening") {
            milestoneListWindowScreening.reverse();
            this.tempScreeningMilestoneWindow = milestoneListWindowScreening;
            for (let k = 0; k < milestoneListWindowScreening.length; k++) {
              const currBegin = milestoneListWindowScreening[k].startRangeScreening;
              const currEnd = milestoneListWindowScreening[k].endRangeScreening;
              for (let j = 0; j < milestoneListWindowScreening.length; j++) {
                const innerBegin = milestoneListWindowScreening[j].startRangeScreening;
                const innerEnd = milestoneListWindowScreening[j].endRangeScreening;
                if (k !== j && ((currBegin >= innerBegin && currBegin <= innerEnd) || (currEnd >= innerBegin && currEnd <= innerEnd))) {
                  toastr.error(`${milestoneText} days are overlapping.`);
                  return;
                }
              }
            }
          }
          if (type != "screening") {
            this.tempMilestoneWindow = milestoneListWindow;
            for (let k = 0; k < milestoneListWindow.length; k++) {
              const currBegin = milestoneListWindow[k].startRange;
              const currEnd = milestoneListWindow[k].endRange;
              for (let j = 0; j < milestoneListWindow.length; j++) {
                const innerBegin = milestoneListWindow[j].startRange;
                const innerEnd = milestoneListWindow[j].endRange;
                if (k !== j && ((currBegin >= innerBegin && currBegin <= innerEnd) || (currEnd >= innerBegin && currEnd <= innerEnd))) {
                  toastr.error(`${milestoneText} days are overlapping.`);
                  return;
                }
              }
            }
          }
        }

        return milestoneArr;
      } else {
        toastr.error(`Please set up your Study's ${milestoneText} or click 'I do not want to set up milestones' to continue.`);
      }
    },
    previousQuestion() {
      switch (this.step) {
        case 5:
          if (!this.questionnaire.support) {
            this.step = this.step - 1;
          }
          this.step = this.step - 1;
          break;
        case 9:
          this.addOption = false;
          this.step = this.step - 1;
          this.step = this.calculateNextOrPrevStep("decrement");
          break;
        case 10:
          this.addOption = false;
          this.step = this.step - 1;
          break;
        case 12:
          if (["Phase 2 Clinical Trial", "Phase 3 Clinical Trial"].indexOf(this.questionnaire.type) >= 0) {
            this.questionnaire.subType = this.questionsList[11].options[0];
            this.step = this.step - 1;
          }
          this.step = this.step - 1;
          break;
        case 15:
          this.step = this.step - 1;
          break;
        default:
          this.step = this.step - 1;
          break;
      }
    },
    getStepNumber(step) {
      let nextStep = step;
      nextStep += 1;
      if (this.questionIndices.indexOf(nextStep) < 0) {
        nextStep += 1;
        if (this.questionIndices.indexOf(nextStep) < 0) {
          nextStep += 1;
        }
      }
      return nextStep;
    },
    addOptions() {
      if (this.step === 9 && this.questionnaire.targetPatients.length <= 7) {
        this.addOption = true;
        this.showAlert = false;
      } else if (this.step !== 10) {
        this.addOption = true;
        this.showAlert = false;
      }
    },
    removedLinkedCountry() {
      const selectedcountryIds = this.selectedCountries.map(obj => obj.countryId);
      for (const key in this.linkedLC) {
        if (!selectedcountryIds.includes(key)) {
          delete this.linkedLC[key];
        }
      }
    },
    addLinkedLanguages() {
      if (!this.selectedCountries && !this.questionnaire.studyLanguage) {
        return;
      }
      this.filteredStudyLanguage = this.questionnaire.studyLanguage.filter(data => {
        if (data.active == true) {
          return data;
        }
      });
      this.filteredStudyLanguageIds = this.questionnaire.studyLanguage
        .filter(data => {
          if (data.active == true) {
            return data;
          }
        })
        .map(obj => obj.language_id);

      for (const singleCountry of this.selectedCountries) {
        if (this.linkedLC[singleCountry.countryId]) {
          continue;
        }
        this.linkedLC[singleCountry.countryId] = _.cloneDeep(this.filteredStudyLanguageIds);
      }
    },
    addLaguageForEachCountry(selectedLang) {
      if (!this.selectedCountries && !selectedLang) {
        return;
      }
      for (const singleCountry of this.selectedCountries) {
        if (!this.linkedLC[singleCountry.countryId] && !!this.defaultLang) {
          this.linkedLC[singleCountry.countryId] = [];
          this.linkedLC[singleCountry.countryId].push(this.defaultLang.language_id);
        }
        if (!this.linkedLC[singleCountry.countryId].includes(selectedLang.language_id)) {
          this.linkedLC[singleCountry.countryId].push(selectedLang.language_id);
        }
      }
    },
    removeLaguageForEachCountry(selectedLang) {
      if (!this.selectedCountries && !selectedLang) {
        return;
      }
      for (const singleCountry of this.selectedCountries) {
        if (!this.linkedLC[singleCountry.countryId]) {
          this.linkedLC[singleCountry.countryId] = [];
        }
        this.linkedLC[singleCountry.countryId] = this.linkedLC[singleCountry.countryId].filter(item => item !== selectedLang.language_id);
      }
    },
    selectedLanguage(selected) {
      let langPresent = null;
      langPresent =
        this.questionnaire.language.length > 0 &&
        this.questionnaire.language.filter(lang => {
          return lang.name.toLowerCase() === selected.name.toLowerCase() && lang.active != false;
        });
      if (langPresent == null || langPresent.length == 0) {
        if (selected.active == false) {
          selected.active = true;
          this.selLanguage = null;
          return;
        }
        this.questionnaire.language.push(_.cloneDeep(selected));
        this.$set(selected, "draft", false); // By default the newly added lang is 'Live'
        this.questionnaire.studyLanguage.push(selected);
        //add newly added language for each selected country
        this.addLaguageForEachCountry(selected);
        this.selLanguage = null;
        return;
      }
      toastr.error(selected.name + " is already selected. Please choose another language");
      this.selLanguage = null;
    },
    saveUploadFileOnLocal(event) {
      const input = window.document.getElementById("upload-file-input");

      if (input.files[0] == null || input.files[0] == undefined) {
        toastr.error("Please upload translation file");
        return;
      }
      this.settingFile.currentFile = {
        file: input.files[0],
        name: input.files[0].name,
        displayName: input.files[0].name,
        documentId: this.settingFile.currentFile.documentId ? this.settingFile.currentFile.documentId : null
      };
      event.target.value = null;
      this.showUploadReadOnlySection = !!(this.settingFile.currentFile.file && this.applangaAccessToken);
      this.showUploadFileSection = !(this.settingFile.currentFile.file && this.applangaAccessToken);
    },
    showRemoveLanguageModal(lang, index) {
      this.langObjNeedToBeDeleted.lang = lang;
      this.langObjNeedToBeDeleted.index = index;
      this.$refs["remove-language-modal"].show();
    },
    removeLanguage(status) {
      if (!status) {
        this.$refs["remove-language-modal"].hide();
        return;
      }
      this.$refs["remove-language-modal"].hide();
      this.questionnaire.language[this.langObjNeedToBeDeleted.index].active = false;
      this.questionnaire.studyLanguage[this.langObjNeedToBeDeleted.index].active = false;
      this.removeLaguageForEachCountry(this.langObjNeedToBeDeleted.lang);
      toastr.success("Language has been removed.");
      this.getActiveLanguageCount();
    },
    getActiveLanguageCount() {
      const arr = this.questionnaire.studyLanguage.filter(data => {
        if (data.active == true) {
          return data;
        }
      });
      return arr.length;
    },
    showDeletetransaltionModal() {
      this.$refs["del-transaltion-modal"].show();
    },
    delTransaltion(status) {
      this.$refs["del-transaltion-modal"].hide();
      if (!status) {
        return;
      }
      this.settingFile.currentFile.displayName = null;
      this.settingFile.currentFile.file = null;
      this.showUploadFileSection = true;
      this.showUploadReadOnlySection = false;
      this.applangaAccessToken = null;
      toastr.success("File has been removed.");
    },
    removeTargetPatients(selectedPatient) {
      const index = this.questionnaire.targetPatients.indexOf(selectedPatient);
      this.questionnaire.targetPatients.splice(index, 1);
      this.showAlert = false;
      this.setPointerOnDiseaseInput();
    },
    selectedPatientPopulations(val) {
      if (val) {
        if (this.questionnaire.targetPatients.indexOf(val) < 0) {
          this.questionnaire.targetPatients.push(val);
          this.selected = "";
          this.studySearchedDiseases = [];
          this.populationIndex = -1;
          this.showAlertOther = false;
          this.addOption = false;
          this.patiantInput = false;
        } else {
          this.showAlertOther = true;
        }
      } else {
        this.addOption = false;
        this.patiantInput = this.questionnaire.targetPatients.length < 6;
      }
      this.setPointerOnDiseaseInput();
    },
    buttonSelected(value, step) {
      switch (step) {
        case 3:
          if (this.questionnaire.countryList && this.questionnaire.countryList.length > 0) {
            this.addOption = false;
          }
          if (value === "No thanks") {
            this.step = this.getStepNumber(this.step);
            this.questionnaire.support = false;
          } else {
            this.questionnaire.support = true;
          }
          break;
        case 8:
          this.questionnaire.subType = value;
          break;
        default:
          break;
      }
      this.step = this.getStepNumber(this.step);
    },
    addMilestone(milestoneType) {
      const template = {
        sortOrder: 0,
        milestoneName: null,
        milestoneDay: null,
        durationMinus: null,
        durationPlus: null,
        displayName: null,
        segments: [],
        milestoneType: milestoneType
      };
      if (milestoneType == "screening") {
        this.questionnaire.screeningMilestoneList.push(template);
        this.prepareCohortCheckboxes(this.questionnaire.screeningMilestoneList, "screening");
        this.removeIconInMilestone(this.questionnaire.screeningMilestoneList);
      } else {
        this.questionnaire.milestonesList.push(template);
        this.prepareCohortCheckboxes(this.questionnaire.milestonesList, null);
      }
      this.$forceUpdate();
    },
    getFormsForMilestone() {
      Promise.all([this.$api.getEDCFormsFact(this.studyId), this.$api.getUnscheduledPacketsFact(this.studyId)]).then(result => {
        const scheduledEdcForms = result[0].ok
          ? result[0].body.map(e => {
              if (e.milestonesList.length > 0) {
                return e.milestonesList;
              }
            })
          : [];
        const unscheduledPacketForms = result[1].ok
          ? result[1].body.map(e => {
              if (e.milestonesList.length > 0) {
                return e.milestonesList;
              }
            })
          : [];

        this.scheduledEdcForms =
          scheduledEdcForms.length > 0
            ? scheduledEdcForms
                .filter(e => {
                  if (e !== undefined) {
                    return e;
                  }
                })
                .flat()
            : [];
        this.unscheduledPacketForms =
          unscheduledPacketForms.length > 0
            ? unscheduledPacketForms
                .filter(e => {
                  if (e !== undefined) {
                    return e;
                  }
                })
                .flat()
            : [];
      });
    },
    removeMilestone(selected, index, type) {
      const secheduledCount = this.scheduledEdcForms.map(e => {
        return e.milestoneId;
      });
      const unsecheduledCount = this.unscheduledPacketForms.map(e => {
        return e.milestoneId;
      });

      if (secheduledCount.includes(selected.milestoneId) || unsecheduledCount.includes(selected.milestoneId)) {
        toastr.error("You have scheduled activities and/or notifications associated with this milestone. Please remove them first before deleting this milestone.");
      } else if (this.questionnaire.canMilestonesModifyList && _.includes(this.questionnaire.canMilestonesModifyList, selected.milestoneId)) {
        toastr.error("You have scheduled activities and/or notifications associated with this milestone. Please remove them first before deleting this milestone.");
        return;
      } else {
        swal({
          title: "Are you sure you want to delete this?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#f16559",
          confirmButtonText: "Cancel",
          cancelButtonText: "Delete"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            if (type && type == "screening") {
              this.questionnaire.screeningMilestoneList.splice(index, 1);
            } else {
              this.questionnaire.milestonesList.splice(index, 1);
            }
            this.$forceUpdate();
          }
        });
      }
    },
    cannotModifyMilestone(selected) {
      const secheduledCount = this.scheduledEdcForms.map(e => {
        return e.milestoneId;
      });
      const unsecheduledCount = this.unscheduledPacketForms.map(e => {
        return e.milestoneId;
      });
      if (secheduledCount.includes(selected.milestoneId) || unsecheduledCount.includes(selected.milestoneId)) {
        toastr.error("You have scheduled activities and/or notifications associated with this milestone. Please remove them first before editing this milestone.");
      } else if (this.questionnaire.canMilestonesModifyList && _.includes(this.questionnaire.canMilestonesModifyList, selected.milestoneId)) {
        toastr.error("You have scheduled activities and/or notifications associated with this milestone. Please remove them first before editing this milestone.");
      }
      this.$forceUpdate(); //this forceupdate will display the old milestone value instead of the new one
    },
    calculateStartEndDuration(questionnaire) {
      setTimeout(() => {
        if (questionnaire.studyStartDate && questionnaire.studyEndDate) {
          const sed = +this.getExactDayEpoch(questionnaire.studyEndDate);
          const ssd = +this.getExactDayEpoch(questionnaire.studyStartDate);
          this.questionnaire.startEndDuration = Math.ceil((sed - ssd) / 1000 / 86400);
        }
        this.$forceUpdate();
      }, 10);
    },
    calculateWeeks(questionnaire) {
      setTimeout(() => {
        if (questionnaire.firstPatientEnrollDate && questionnaire.firstPatientLastDate) {
          const fpld = +this.getExactDayEpoch(questionnaire.firstPatientLastDate);
          const fped = +this.getExactDayEpoch(questionnaire.firstPatientEnrollDate);
          this.questionnaire.studyDuration = Math.ceil((fpld - fped) / 1000 / 86400);
        }
        this.$forceUpdate();
      }, 10);
    },
    calculateLatPatientDuration(questionnaire) {
      setTimeout(() => {
        if (questionnaire.lastPatientEnrollDate && questionnaire.lastPatientLastDate) {
          const lpld = +this.getExactDayEpoch(questionnaire.lastPatientLastDate);
          const lped = +this.getExactDayEpoch(questionnaire.lastPatientEnrollDate);
          this.questionnaire.lastPatientDuration = Math.ceil((lpld - lped) / 1000 / 86400);
        }
        this.$forceUpdate();
      }, 10);
    },
    studyDates() {
      if (this.questionnaire.continuousStudy) {
        this.questionnaire.lastPatientEnrollDate = "";
        this.questionnaire.lastPatientLastDate = "";
      }
      this.$forceUpdate();
    },
    selectApp(app) {
      if (app === "ios") {
        this.questionnaire.ios = !this.questionnaire.ios;
      } else if (app === "android") {
        this.questionnaire.android = !this.questionnaire.android;
      } else if (app === "web") {
        this.questionnaire.web = !this.questionnaire.web;
      }
    },
    setConfigurationDetail(event) {
      if (this.questionnaire.participantIdEnabled == false) {
        this.questionnaire.participantIdFormatConfigured.isFormattingChecked = false;
        this.isConfigurationDetailSectionEnabled = event.target.checked;
        this.questionnaire.participantIdFormatConfigured.size = null;
        this.questionnaire.participantIdFormatConfigured.format = null;
        this.formatArray = [];
        this.questionnaire.participantIdFormatConfigured.isDisallowLetters = false;
        this.questionnaire.participantIdFormatConfigured.isDisallowNumbers = false;
        this.questionnaire.participantIdFormatConfigured.isDisallowSpecialCharacters = false;
        this.questionnaire.participantIdFormatConfigured.colorCodingEnable = false;
        this.questionnaire.participantIdColorCodingMetaData = [];
        this.questionnaire.isParticipantIdRequired = false;
        this.questionnaire.isParticipantIdEditable = false;
        this.questionnaire.allowDuplicatePid = false;
      }
    },
    showConfigurationDetail(event) {
      this.isConfigurationDetailSectionEnabled = event.target.checked;
      this.resetParticipantIdFormatConfigured();
    },
    sizeChangeDetection(ele) {
      let shouldFormatArrhasValue = true;
      const sizePid = ele.target.value;
      const arrLenght = this.questionnaire.participantIdColorCodingMetaData.length + 1;
      if (arrLenght < sizePid) {
        this.displayAddColorCodeBtn = true;
      }
      if (arrLenght == sizePid) {
        this.displayAddColorCodeBtn = false;
      }
      if (ele.target.value == 0) {
        this.questionnaire.participantIdFormatConfigured.errors = "Please specify the maximum number of characters.";
        shouldFormatArrhasValue = false;
      } else if (isNaN(ele.target.value)) {
        this.questionnaire.participantIdFormatConfigured.errors = "Numeric entries only";
        shouldFormatArrhasValue = false;
      } else if (Number(ele.target.value) > 99) {
        this.questionnaire.participantIdFormatConfigured.errors = "Max number of characters cannot exceed 99";
        shouldFormatArrhasValue = false;
      } else if (Math.sign(ele.target.value) < 0) {
        this.questionnaire.participantIdFormatConfigured.errors = "Negative values are not allowed";
        shouldFormatArrhasValue = false;
      } else if (ele.target.value == "") {
        shouldFormatArrhasValue = false;
      }
      const size = shouldFormatArrhasValue ? ele.target.value : null;
      this.questionnaire.participantIdFormatConfigured.errors = shouldFormatArrhasValue ? null : this.questionnaire.participantIdFormatConfigured.errors;
      this.questionnaire.participantIdFormatConfigured.size = ele.target.value;
      this.formatArray = [];
      this.formatArray.push(new Array(Number(size)).fill(null));
      if (this.questionnaire.participantIdColorCodingMetaData.length > 0) {
        for (let i = 0; i < this.questionnaire.participantIdColorCodingMetaData.length; i++) {
          this.characterChangeDetection(this.questionnaire.participantIdColorCodingMetaData[i], i);
        }
      }

      this.$forceUpdate();
    },
    changeLangMode(lang) {
      lang.draft = !lang.draft;
    },
    sortLatinArray() {
      const lang = this.latinAmericaLanguages;
      return lang.sort();
    },
    checkColorCodingEnable() {
      if (this.questionnaire.participantIdFormatConfigured.colorCodingEnable && this.questionnaire.participantIdColorCodingMetaData.length == 0) {
        this.addNewColorConfig();
      } else if (!this.questionnaire.participantIdFormatConfigured.colorCodingEnable) {
        this.questionnaire.participantIdColorCodingMetaData = [];
      }
    },
    addNewColorConfig() {
      const size = this.questionnaire.participantIdFormatConfigured.size;
      const arrLenght = this.questionnaire.participantIdColorCodingMetaData.length + 1;
      if (size == arrLenght) {
        this.displayAddColorCodeBtn = false;
      }
      const obj = {
        colorCodeCharacter: "",
        colorCodeCondition: "None",
        colorCodeConditionValue: "",
        color: "#FF0000",
        active: false
      };
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = false;
      this.questionnaire.participantIdColorCodingMetaData.push(obj);
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = true;
    },
    deleteColorConfig(index) {
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = false;
      this.questionnaire.participantIdColorCodingMetaData.splice(index, 1);
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = true;
    },
    isNumber(evtOld, digit, index) {
      let evt = evtOld;
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        if (isNaN(parseInt(digit.colorCodeCharacter))) {
          this.characterChangeDetection(digit, index);
        } else {
          digit.colorCodeCharacter = parseInt(digit.colorCodeCharacter);
        }
        return false;
      }
      return true;
    },
    characterChangeDetection(digit, index) {
      if (this.questionnaire.participantIdFormatConfigured.size == "" || this.questionnaire.participantIdFormatConfigured.size == null) {
        toastr.error("Please restrict the number of characters first.");
        return;
      }
      let hasColorConfigError = true;
      digit.errorChar = "";
      this.questionnaire.participantIdColorCodingMetaData.forEach((item, i) => {
        if (index != i) {
          if (digit.colorCodeCharacter == item.colorCodeCharacter) {
            digit.errorChar = "Duplicate setup.";
          }
        }
      });

      if (!this.questionnaire.participantIdFormatConfigured.size) {
        digit.errorChar = "Please specify the maximum number of characters.";
        hasColorConfigError = false;
      } else if (digit.colorCodeCharacter == 0) {
        digit.errorChar = "Entered character must be greater than zero.";
        hasColorConfigError = false;
      } else if (isNaN(digit.colorCodeCharacter)) {
        digit.errorChar = "Numeric entries only.";
        hasColorConfigError = false;
      } else if (Number(digit.colorCodeCharacter) > this.questionnaire.participantIdFormatConfigured.size) {
        digit.errorChar = "Entered character cannot be greater than the maximum length of PID.";
        hasColorConfigError = false;
      } else if (Math.sign(digit.colorCodeCharacter) < 0) {
        digit.errorChar = "Entered character must be greater than zero.";
        hasColorConfigError = false;
      } else if (digit.colorCodeCharacter == "" || digit.colorCodeCharacter == null) {
        hasColorConfigError = false;
        digit.errorChar = "Please specify the number of characters.";
      }
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = false;
      this.$forceUpdate();
      this.colorError = hasColorConfigError ? null : this.colorError;
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = true;
    },
    selectedColorConditionLogic(digit, index) {
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = false;
      this.questionnaire.participantIdColorCodingMetaData[index].colorCodeCondition = digit.colorCodeCondition;
      if (this.questionnaire.participantIdColorCodingMetaData[index].colorCodeCondition == "None") {
        this.questionnaire.participantIdColorCodingMetaData[index].colorCodeConditionValue = "";
      }
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = true;
    },
    colorCodeConditionValueDetection(ele, digit, index) {
      if (this.questionnaire.participantIdFormatConfigured.isDisallowLetters && /[a-zA-Z]/g.test(ele.target.value)) {
        toastr.error("Letters are not allowed.");
      } else if (this.questionnaire.participantIdFormatConfigured.isDisallowNumbers && /[0-9]/g.test(ele.target.value)) {
        toastr.error("Numbers are not allowed.");
      } else if (this.questionnaire.participantIdFormatConfigured.isDisallowSpecialCharacters && /[[\];=!@#$%^&*(),.?":{}|<>+~/`-]/g.test(ele.target.value)) {
        toastr.error("Special characters are not allowed.");
      } else {
        this.colorError = "";
      }

      if (this.questionnaire.participantIdColorCodingMetaData[index].colorCodeConditionValue.length >= 2) {
        this.questionnaire.participantIdFormatConfigured.colorCodingEnable = false;
        this.questionnaire.participantIdColorCodingMetaData[index].colorCodeConditionValue = "";
        this.questionnaire.participantIdFormatConfigured.colorCodingEnable = true;
      }
      return this.colorError;
    },
    deleteColorConfigAlert(index) {
      this.$swal({
        title: "Are you sure you want to delete?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4a4a4a",
        cancelButtonColor: "#1e8fe1",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.deleteColorConfig(index);
          const size = this.questionnaire.participantIdFormatConfigured.size;
          const arrLenght = this.questionnaire.participantIdColorCodingMetaData.length;
          if (arrLenght < size) {
            this.displayAddColorCodeBtn = true;
          }
        }
      });
    },
    setColor: function(color, colorName, colorInd) {
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = false;
      this.questionnaire.participantIdColorCodingMetaData[colorInd].active = false;
      this.questionnaire.participantIdColorCodingMetaData[colorInd].color = color;
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = true;
    },
    toggleDropdown: function(index) {
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = false;
      this.questionnaire.participantIdColorCodingMetaData &&
        this.questionnaire.participantIdColorCodingMetaData.filter((data, dataIndx) => {
          if (dataIndx == index) {
            this.questionnaire.participantIdColorCodingMetaData[index].active = !this.questionnaire.participantIdColorCodingMetaData[index].active;
          } else {
            data["active"] = false;
          }
        });
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = true;
    },
    selectedValueColor(index) {
      return '<span style="padding: 2px 20px 2px 0px;margin-right: 5px; margin-left: 5px;border-radius: 50%;background: ' + this.questionnaire.participantIdColorCodingMetaData[index].color + '"></span> ';
    },
    colorDropdownClose() {
      const colorEnableState = this.questionnaire.participantIdFormatConfigured.colorCodingEnable;
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = false;
      this.questionnaire.participantIdColorCodingMetaData &&
        this.questionnaire.participantIdColorCodingMetaData.filter(data => {
          data["active"] = false;
        });
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = colorEnableState;
    },
    copyCohort() {
      const copyCohort = Object.assign({}, this.cohort);
      copyCohort.id = uuidv4();
      copyCohort.name = " Copy" + " " + "-" + " " + copyCohort.name;
      const isValid = this.validateCohort(copyCohort);
      if (isValid == false) {
        toastr.error("Duplicate cohort");
        return;
      }
      this.questionnaire.segments.push(copyCohort);
      this.cohort = undefined;
      this.showEditCohortScreen = false;
      toastr.success("Cohort copied");
    },
    findWithAttr(id) {
      const index = this.questionnaire.segments.findIndex(element => element.id === id);
      return index;
    },
    deleteCohort() {
      const index = this.findWithAttr(this.cohort.id);

      if (index != -1) {
        const delCohort = this.questionnaire.segments[this.questionnaire.segments.findIndex((data, i) => i === index)];
        const isDeleted = this.questionnaire.milestonesList.some(milestone => milestone.segments.includes(delCohort.id));
        if (isDeleted) {
          this.$toastr.error("You have milestones, scheduled activities and/or notifications associated with this cohort. Please remove them first before deleting this cohort.");
        } else {
          this.questionnaire.segments.splice(index, 1);
          toastr.success("Cohort deleted");
        }
        this.showEditCohortScreen = false;
      }
    },
    cancelEditCohort() {
      this.showEditCohortScreen = false;
      this.cohort = undefined;
      for (let i = 0; i < this.questionnaire.segments.length; i++) {
        if (this.questionnaire.segments[i].id === this.cancelCohortName.id) {
          this.questionnaire.segments[i] = Object.assign({}, this.cancelCohortName);
        }
      }
    },
    validateCohort(cohort) {
      if (!!this.questionnaire.segments && this.questionnaire.segments.length) {
        for (let i = 0; i < this.questionnaire.segments.length; i++) {
          if (this.questionnaire.segments[i].name === cohort.name) {
            return false;
          }
        }
      }
      return true;
    },
    saveEditCohort() {
      const index = this.findWithAttr(this.cohort.id);
      if (index !== -1) {
        const isValid = this.validateCohort(this.cohort);
        if (isValid == false && this.questionnaire.segments[index].id != this.cohort.id) {
          toastr.error("Duplicate cohort");
          return;
        }

        this.questionnaire.segments[index].name = this.cohort.name;
        this.questionnaire.segments[index].description = this.cohort.description;
        this.cohort = undefined;
        toastr.success("Cohort edited");
      }
      this.showEditCohortScreen = false;
    },
    saveCohort() {
      const isValid = this.validateCohort(this.cohort);
      if (isValid == false) {
        toastr.error("Duplicate cohort");
        return;
      }
      this.cohort.id = uuidv4();
      this.cohort.milestones = [];
      if (!this.questionnaire.hasOwnProperty("segments")) {
        this.$set(this.questionnaire, "segments", []);
      }
      this.questionnaire.segments.push(this.cohort);
      this.cohort = undefined;
      this.showAddCohortScreen = false;
      toastr.success("Cohort created");
    },
    editCohort(cohort) {
      if (this.questionnaire.isSegmentSupported == true) {
        this.cohort = cohort;
        this.showAddCohortScreen = false;
        this.showEditCohortScreen = true;
        this.cancelCohortName = Object.assign({}, this.cohort);
      }
    },
    addCohort() {
      if (this.questionnaire.isSegmentSupported == true) {
        this.cohort = {};
        this.cohort.name = null;
        this.cohort.description = null;
        this.showAddCohortScreen = true;
        this.showEditCohortScreen = false;
      }
    },
    cancelCohort() {
      this.showAddCohortScreen = false;
      this.cohort = undefined;
    },
    studyCohortChanged() {
      if (this.questionnaire.isSegmentSupported == true && this.questionnaire.segments && this.questionnaire.segments.length == 0) {
        this.addCohort();
      }
      if (this.questionnaire && this.questionnaire.milestonesList) {
        this.questionnaire.milestonesList.forEach(milestone => (milestone.segments = []));
      }

      if (this.questionnaire && this.questionnaire.screeningMilestoneList) {
        this.questionnaire.screeningMilestoneList.forEach(milestone => (milestone.segments = []));
      }
    },
    getSelectedCohortText(milestone) {
      if (milestone && milestone.segments && milestone.segments.length) {
        if (milestone.segments.length > 0) {
          return `${milestone.segments.length} selected`;
        }
      } else {
        return "All Participants";
      }
    },
    isCohortAdded(event, milestone, cohortIndex) {
      if (!this.questionnaire.segments[cohortIndex].hasOwnProperty("milestones")) {
        this.$set(this.questionnaire.segments[cohortIndex], "milestones", []);
      }
      const mIndex = this.questionnaire.segments[cohortIndex].milestones.indexOf(milestone);
      if (event) {
        if (mIndex == -1) {
          this.questionnaire.segments[cohortIndex].milestones.push(milestone);
        }
        toastr.success("Milestone assigned Cohort");
      } else {
        this.questionnaire.segments[cohortIndex].milestones.splice(mIndex, 1);
        toastr.success("Milestone removed Cohort");
      }
    },
    isConfiguredInActivity(milestoneId) {
      return _.includes(this.questionnaire.canMilestonesModifyList, milestoneId);
    },
    removeRTSMIntegration() {
      this.$api.deleteIntegrationVendorSelection(this.studyId).catch(() => {
        this.$toastr.error("An error occured while trying to remove RTSM integration settings.");
      });
    },
    isStudyActive() {
      return this.questionnaire.status === ACTIVE;
    },
    addManualStartCustomClass() {
      document.body.classList.add("rtsm-custom-manual-start");
    },
    removeManualStartCustomClass() {
      setTimeout(() => {
        document.body.classList.remove("rtsm-custom-manual-start");
      }, 1000);
    },
    resetParticipantIdFormatConfigured(shouldHideDetailSection = false) {
      if (shouldHideDetailSection) {
        this.isConfigurationDetailSectionEnabled = false;
      }

      this.questionnaire.participantIdFormatConfigured.size = null;
      this.questionnaire.participantIdFormatConfigured.format = null;
      this.formatArray = [];
      this.questionnaire.participantIdFormatConfigured.isDisallowLetters = false;
      this.questionnaire.participantIdFormatConfigured.isDisallowNumbers = false;
      this.questionnaire.participantIdFormatConfigured.isDisallowSpecialCharacters = false;
      this.questionnaire.participantIdFormatConfigured.colorCodingEnable = false;
      this.questionnaire.participantIdColorCodingMetaData = [];
    }
  },
  directives: {
    "no-leading-zero": {
      bind: function(el) {
        el.addEventListener("input", function(event) {
          const inputValue = event.target.value.trim();
          if (inputValue.startsWith("0")) {
            event.target.value = inputValue.replace(/^0+/, "");
            event.target.dispatchEvent(new Event("input"));
          }
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
// Style for quick fixes bootstrap after migration (before redesign should be removed)

.btn {
  font-size: 14px;
}
/deep/ .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(/static/img/right.png);
}

.custom-study-textarea {
  margin-top: 16px;
  border-radius: 0.25rem;
}

.col-xs-12 {
  width: 100%;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
.access-token-wrap {
  width: 50%;
  margin: 0 auto;
}
.countries-wrap {
  padding-top: 27px;
  padding-bottom: 35px;
}
.set-full-width {
  min-width: 75%;
}
.country-group {
  text-align: left;
  width: 630px;
  margin: 0 auto;
}
.single-country-box {
  width: 100%;
  height: 35px;
  margin: 10px 0px -1px 0px;
  padding: 5px 0px;
  border-radius: 8px 8px 0px 0px;
  border: solid 1px #d3dee3;
  background-color: #f3f7f9;
  display: flex;

  .country-name {
    margin: 0px;
    opacity: 0.7;
    font-family: Roboto sans-serif;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #666669;
  }
}

.single-country-box.collapsed {
  border-radius: 8px;
}

.single-country-box.collapsed i {
  transform: rotateZ(-90deg);
  transition: all 0.4s ease;
}

.lang-group {
  width: 100%;
  margin: 0px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border: solid 1px #d3dee3;
  display: inline-block;
  text-align: left;
  padding: 15px;

  .form-group {
    margin-bottom: 0px;
  }
  /deep/ .custom-control-label {
    padding-top: 2.2px !important;
  }
}

.round {
  display: inline-block;
  width: 22px;
  background-color: #1e8fe1;
  height: 22px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 12px;
  color: white;
  font-size: 12px;
  text-align: center;
  padding: 2px;
}
.display-inline {
  display: inline-block;
}
.col-xs-10 {
  width: 83.33333333%;
}

.panel-default {
  border-color: #ddd;
}

.col-lg-offset-2 {
  margin-left: 16.66666667%;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
.btn-container {
  display: flex;
  .lang-cult {
    background-color: #959fa4;
    border-radius: 4px;
    color: #fff;
    font-family: "RobotoRegular";
    padding: 0px 7px;
    display: -ms-inline-flexbox;
    display: inline-flex;
    display: -webkit-inline-box;
    font-size: 10px;
    margin-top: auto;
    margin-bottom: 4px;
    margin-right: 6px;
    height: 0%;
  }
  .selected-lang {
    text-align: left;
  }
  .draft-label {
    background-color: #b8c7ce;
    border-radius: 4px;
    color: #fff;
    font-family: "RobotoRegular";
    padding: 0px 10px;
    height: 0%;
    margin-left: 10px;
    margin-top: 12px;
    margin-bottom: 0;
    display: inline-flex;
    font-size: 13px;
  }
  .set-btn {
    background-color: #fff;
    border-radius: 4px;
    color: #4c8ce4;
    font-family: "RobotoRegular";
    border: 1px solid #b8c7ce;
    padding: 0 15px;
    height: 0%;
    margin-left: auto;
    margin-right: 11px;
    margin-top: 10px;
    margin-bottom: 0;
    &:hover {
      cursor: pointer;
      border: 1px solid #4c8ce4;
    }
  }
  .remove-selected {
    text-align: right;
    cursor: pointer;
    color: #f16a5e;
  }
  .lang-cult {
    background-color: #959fa4;
    border-radius: 4px;
    color: #fff;
    font-family: RobotoRegular;
    padding: 0 7px;
    display: -ms-inline-flexbox;
    display: inline-flex;
    display: -webkit-inline-box;
    font-size: 10px;
    margin-top: auto;
    margin-bottom: 4px;
    margin-right: 6px;
    height: 0%;
  }
}
.lang-note {
  font-size: 13px;
}
.ps-note {
  font-size: 12px;
  color: #1e8fe1;
  cursor: pointer;
  a {
    color: #1e8fe1 !important;
  }
}
.remove-upload-file {
  padding: 0px 20px;
}
.up-title {
  text-align: left;
}
.upload-wrap {
  padding: 3px;
  border: 1px solid #1e8fe1;
  display: table;
  color: #1e8fe1;
  border-radius: 5px;
  width: 180px;
  text-align: center;
  display: inline-block;
  margin: 0px;
  height: 29px;
  font-size: 13px;
}
.api-input {
  height: 29px;
  width: 180px;
}

.api-input::placeholder {
  /* Firefox, Chrome, Opera */
  color: #495057 !important;
}

.api-input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #495057 !important;
}

.api-input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #495057 !important;
}

.upload-properties {
  display: none;
}
.upload-area {
  float: left;
  text-align: left;
}
.del-link {
  float: right;
  font-size: 12px;
  color: #f16a5e;
  cursor: pointer;
}
.fa {
  padding-right: 5px;
}
.fa-file:before {
  color: #4c8ce4;
}
.modal-body {
  .title {
    padding: 15px 15px 20px;
    font-weight: 600;
    &.no-padding {
      padding-bottom: 0px;
    }
  }
  .description {
    padding: 0px 22px 20px;
  }
  .btn-grp {
    padding-bottom: 20px;
    button {
      padding: 5px 25px;
      border-radius: 5px;
      margin-right: 15px;
    }
    .confirm-btn {
      background-color: #1e8fe1;
      border: 1px solid #1e8fe1;
      color: #ffffff;
      padding: 5px 35px;
    }
    .cancel-btn {
      background: transparent;
      border: 1px solid #b0bac9;
    }
  }
}
/deep/.custom-checkbox .custom-control-label::before {
  width: 17px;
  height: 17px;
  border-radius: 2px;
  top: 0.25rem;
}
/deep/ .custom-control-inline {
  width: auto;
  margin-right: 15px;
  display: inline-block;
}
/deep/ .custom-control-label {
  padding-top: 0px;
}
/deep/ .custom-control-label::after {
  position: absolute;
  left: 0px;
  top: 0.25rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 70% 65%;
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    //flex: none;
    display: block;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-10 {
    width: 83.33333333%;
  }
  .navbar-toggler {
    display: none;
  }
  .navbar-right {
    float: right !important;

    .navbar-nav {
      flex-direction: row;
    }

    li {
      float: left;
    }
  }
}
@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    //flex: none;
    display: block;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

.has-header {
  margin-top: 53px;
  padding-top: 100px;
}

.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  color: grey;
  background-color: #fff;
}

.dropdown-menu > li > a {
  color: grey !important;
  padding: 5px 0px 5px 0px;
}

.target-patients {
  width: 100%;
}
.target-patients a {
  display: block;
}

.navigate-dropdown {
  background-color: #34537d !important;
  color: #fff !important;
}

.feedbackStyle {
  z-index: 99;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 10px 0px;
  text-align: right;
  height: 60px;
}

.oval {
  padding: 18px 14px;
  background-color: #ffffff;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 25px;
}
.filter-form-box {
  width: 100%;
}
.day_text {
  background-color: #f5f8fa;
}

.custom-days-block {
  background-color: #f5f8fa;
  border: 1px solid #d3dee3;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.milestone-wrap {
  border: 1px solid #d3dee3;
  min-height: 136px;
  height: 60.2%;
  font-size: 12px;
  .top-wrapper {
    border-bottom: 1px solid #d3dee3;
    overflow: hidden;
  }
  .middel-wrapper {
    border-bottom: 1px solid #d3dee3;
    overflow: hidden;
    .days-block {
      background-color: #f5f8fa;
      padding: 6px;
      border-left: 1px solid #d3dee3;
      height: 32.5px;
    }
  }
  .bottom-wrapper {
    .days-block {
      background-color: #f5f8fa;
      padding: 6px;
      border-left: 1px solid #d3dee3;
      height: 33px;
    }
  }
  .border-none {
    border-top: none;
    border-bottom: none;
    border-left: 1px solid #ced4da;
    border-right: 1px solid #ced4da;
  }
  .border-none:focus {
    box-shadow: none;
  }
}
.span-block {
  display: inline-block;
  width: 100%;
  padding: 6px;
  border-right: 1px solid #d3dee3;
  height: 32.8px;
}
.milestone_number {
  border-radius: 0px;
  padding: 0.375rem 0.75rem;
}
.img-size {
  width: 25px;
  height: 25px;
}

.patient_population_readonly {
  word-break: break-all;
  height: inherit;
  margin-bottom: 10px;
}

.container-style {
  width: 100%;
  max-width: inherit;
}

.btn {
  height: 37px;
}

.bg-color {
  background-color: #f5f8fa;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
  min-height: 100vh;
}

.panel-style {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  min-height: 500px;
}

.error_msg {
  background-color: #f5f8fa;
  padding: 10px;
}

.active-background {
  background-color: #195877 !important;
}

.btn-style {
  background-color: #4c8ce4 !important;
  display: inline-block;
  float: none;
  margin: 0;
}
.another_link {
  text-align: left !important;
  padding-left: 16px;
}
.disabledbtn {
  background-color: #d3dfe4 !important;
  pointer-events: none;
  border: #d3dfe4 !important;
}

.form-control {
  overflow: hidden;
}

.icon_style {
  position: absolute;
  height: 33px;
  display: inline-block;
  border-left: 1px solid #ddd;
  top: 21px;
  right: 16px;
  background-color: rgba(85, 85, 85, 0.05);
  width: 35px;
  pointer-events: none;
}

.panel-body-style {
  float: none;
  padding: 50px 0px;
  text-align: center;
  margin: 0 auto;
}

.back_btn {
  position: absolute;
  bottom: 12px;
}

.link-style {
  font-size: 14px;
  text-align: center;
  padding-top: 10px;
  color: #1f95f2;
}

.icon-style {
  position: absolute;
  left: 12px;
  padding-top: 6px;
}

.cal-icon-style {
  position: absolute;
  top: 26px;
  right: 26px;
  cursor: pointer;
  color: #d3dfe4;
  pointer-events: none;
}
.position {
  position: relative;
}

.remove-icon-style {
  position: absolute;
  color: #b8c7ce;
  display: block;
  top: 50px;
  right: -10px;
  cursor: pointer;
}

.days_number {
  position: absolute;
  right: -50px;
  top: 25px;
  font-size: 12px;
  padding: 2px 4px;
  font-weight: 500;
  border-radius: 2px;
  background-color: #68666b;
  border-color: dfe8f5;
  color: #fff;
}

.no-border {
  border: none;
  box-shadow: none;
  text-align: center;
}

.product-card {
  background-color: #f5f8fa;
  border: solid 1px #d3dfe4;
  padding: 20px 0px;
  border-radius: 8px;
  max-width: 115px;
  margin: auto;
  width: 100%;
}

.icon-size {
  font-size: 50px;
  color: #959fa4;
}

.active-card {
  background-color: #4c8ce4;
  border: 1px solid #4c8ce4;
  padding: 20px 0px;
  border-radius: 8px;
  max-width: 115px;
  margin: auto;
  width: 100%;
  position: relative;
}

.active-icon {
  font-size: 50px;
  color: #f5f8fa;
}
.icon-top {
  font-size: 35px;
  color: #71e991;
  position: absolute;
  top: -20px;
  right: -12px;
  background-color: white;
  border-radius: 50%;
  height: 38px;
}
.icon_top {
  font-size: 15px;
  color: #ffffff;
  position: absolute;
  top: -10px;
  right: -12px;
  background-color: #48bf7a;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon_top .fa {
  padding: 0;
}
.question_title {
  font-size: 16px;
  color: #666769;
  /*padding-bottom: 10px;*/
}

.cov-datepicker {
  width: 100%;
}

/* Enter and leave animations can use different */

/* durations and timing functions.              */

.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: none;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(100px);
  opacity: 0;
}

.side-bar {
  height: 300px;
  opacity: 0.8;
  border-radius: 4px;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  border: none !important;
}

.next-icon {
  color: #d3dfe4;
}

.selected-icon {
  color: #4c8ce4;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
  padding-left: 0;
}

.btn-coming-soon {
  position: absolute;
  top: -7px;
  right: 0px;
  font-size: 10px;
  padding: 0px;
  height: 22px;
  width: 85px;
  background-color: #7478e6;
  color: #ffffff;
  cursor: default;
  border-radius: 25px;
}

.disabled_datepicker {
  pointer-events: none;
  opacity: 0.5;
  .datepicker-class {
    background-color: #eee !important;
  }
}

.disabled_input {
  color: #838e93;
  pointer-events: none;
}

.milestone_number {
  text-align: center;
}

.patient_text {
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 2px 12px !important;
}
.hidden {
  display: none !important;
}
.input-bg {
  // background: #ffffff !important;
  color: #4a4a4a !important;
  border: solid 2px #d3dfe4 !important;
  border-radius: 3px;
}
.dot {
  height: 25px;
  width: 25px;
  background-color: Red;
  border-radius: 50%;
  display: inline-block;
}

.select_section {
  select.form-control {
    height: 32px !important;
    line-height: 22px;
  }
}

.show_section {
  select.form-control {
    height: 36px !important;
    line-height: 22px;
  }
}
.remove-block {
  width: 30px;
  height: 30px;
  background-color: lightgray;
  border-radius: 3px;
}

@media (max-width: 575px) {
}

@media (min-width: 576px) and (max-width: 767px) {
}

@media (max-width: 768px) {
  .country-group {
    width: 600px !important;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .container-width {
    width: 700px;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .container-width {
    width: 890px;
  }
  .country-group {
    width: auto !important;
  }
  .last_day {
    width: 245px;
  }
}

@media (min-width: 1200px) {
  .container-width {
    width: 1090px;
  }
}

.edro-warning a {
  color: inherit !important;
  font-weight: bold;
}

/deep/ .enable-disable .custom-radio .custom-control-label::before {
  border-radius: 100%;
  box-shadow: 0 0 0 2px #4c8ce4 !important;
  background-color: white;
  width: 12px !important;
  height: 12px !important;
}
/deep/ .enable-disable .custom-radio .custom-control-label::after {
  border-radius: 100%;
  box-shadow: 0 0 0 2px #4c8ce4 !important;
  background-color: white;
  width: 12px !important;
  height: 12px !important;
}
/deep/ .enable-disable .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: none !important;
  width: 4px !important;
  height: 4px !important;
  margin: 4px;
  background-color: #4c8ce4;
}
/deep/ .enable-disable .custom-control.custom-radio.custom-control-inline {
  min-width: 0px !important;
}

.bs-popover-right {
  width: 374px !important;
  max-width: 500px;
  color: #000000;
}

/deep/ .schedule-feature-radio div:first-child {
  margin-right: 53px !important;
  margin-left: 15px !important;
}

//color select css start
.custom-select {
  position: relative;
  font-family: Arial;
}
.custom-select select {
  display: none;
}
.select-selected:after {
  position: absolute;
  content: "";
  top: 14px;
  right: 10px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: #0d0c0c transparent transparent transparent;
}
.select-selected.select-arrow-active:after {
  border-color: transparent transparent #0d0c0c transparent;
  top: 7px;
}
.select-items div,
.select-selected {
  color: #ffffff;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
  cursor: pointer;
  user-select: none;
}
.select-items {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
}
.select-hide {
  display: none;
}
.select-items div:hover,
.same-as-selected {
  background-color: rgba(0, 0, 0, 0.1);
}
.select-items .square-box {
  height: 18px;
  width: 18px;
  border-radius: 50%;
  float: right;
}
.select-selected .square-box {
  height: 18px;
  width: 18px;
  right: 30px;
  border-radius: 50%;
  position: absolute;
}
//color select end

/deep/ .enable-disable .custom-radio .custom-control-label {
  &:hover {
    cursor: pointer;
  }
}

.latin-america-text {
  color: #4c8ce4;
  cursor: pointer;
  &:focus {
    outline: none !important;
  }
}
.activity-library-table {
  &__container {
    margin: 0 auto;
  }
  &__language-pop-over-container {
    background-color: #ffffff;
    overflow-y: scroll;
    max-height: 258px;
    scrollbar-width: thin; /* "auto" or "thin"  */
    scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */

    &::-webkit-scrollbar {
      width: 5px; /* width of the entire scrollbar */
      max-height: 15%;
    }
    &::-webkit-scrollbar-track {
      background: transparent; /* color of the tracking area */
    }
    &::-webkit-scrollbar-thumb {
      background-color: #b0bac9; /* color of the scroll thumb */
      border-radius: 20px; /* roundness of the scroll thumb */
      border: 3px solid transparent; /* creates padding around scroll thumb */
    }
  }

  &__languages-list {
    list-style: none;
    padding-left: 15px;
    padding-top: 9px;
  }

  &__languages-list-item {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.14;
    letter-spacing: normal;
    color: #000000;
  }

  &__expand-arrow {
    width: 18px;
    height: 18px;
    position: relative;
    top: 4px;
    background-color: white;
  }

  &__collapse-arrow {
    width: 18px;
    height: 18px;
    position: relative;
    top: 4px;
    background-color: white;
    transform: rotateX(180deg);
  }
}
span.err-msg {
  color: red;
  font-size: 12px;
  margin: 0px 0px 0px -14px;
}
/*toggle btn css*/
.switch-toggle-btn {
  position: relative;
  display: inline-block;
  width: 98px;
  height: 24px;
  font-size: 14px;
  top: -2px;
  left: 10px;
  cursor: pointer;
}
.switch-toggle-btn input {
  opacity: 0;
}

.switch-toggle-btn .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e0e0e0;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 15px;
}

.switch-toggle-btn .slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: auto;
  top: 4px;
  background-color: #fff;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}

.switch-toggle-btn input:checked + .slider {
  background-color: #2ecd6c;
}

.switch-toggle-btn input:focus + .slider {
  box-shadow: 0 0 1px #2ecd6c;
}

.switch-toggle-btn input:checked + .slider:before {
  -webkit-transform: translateX(75px);
  -ms-transform: translateX(75px);
  transform: translateX(75px);
}

.switch-toggle-btn .text {
  color: white;
}

.switch-toggle-btn .text:after {
  position: absolute;
  top: 2px;
  right: 15px;
  content: "Disabled";
  -webkit-transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}
.switch-toggle-btn .text:before {
  position: absolute;
  top: 2px;
  left: 15px;
  content: "Enabled";
  -webkit-transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}

.switch-toggle-btn input + .slider + .text:after {
  opacity: 1;
}
.switch-toggle-btn input + .slider + .text:before {
  opacity: 0;
}

.switch-toggle-btn input:checked + .slider + .text:after {
  opacity: 0;
}

.switch-toggle-btn input:checked + .slider + .text:before {
  opacity: 1;
}
//Color dropdown css
.wrapper-dropdown {
  position: relative;
  //width: 100px;
  background: #fff;
  color: #2e2e2e;
  outline: none;
  cursor: pointer;
}
.wrapper-dropdown > span {
  width: 100%;
  display: block;
  border: 1px solid #ababab;
  padding: 5px;
}
.wrapper-dropdown > span > span {
  padding: 0px 20px 0px 0px;
  margin-right: 5px;
  margin-left: 5px;
  border-radius: 50%;
}
.wrapper-dropdown > span:after {
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  right: 7px;
  top: calc(50% + 4px);
  margin-top: -8px;
  border-width: 6px 6px 0 6px;
  border-style: solid;
  border-color: #d3dfe4 transparent;
}

.wrapper-dropdown .dropdown {
  position: absolute;
  z-index: 10;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  font-weight: normal;
  list-style-type: none;
  padding-left: 0;
  margin: 0;
  border: 1px solid #ababab;
  border-top: 0;
}

.wrapper-dropdown .dropdown li {
  display: block;
  text-decoration: none;
  color: #2e2e2e;
  padding: 5px;
  cursor: pointer;
}

.wrapper-dropdown .dropdown li > span {
  padding: 4px 20px 0px 0px;
  margin-right: 5px;
  margin-left: 5px;
  border-radius: 50%;
}

.wrapper-dropdown .dropdown li:hover {
  background: #eee;
  cursor: pointer;
}
.wrapper-dropdown .dropdown-type {
  border: solid 2px #d3dfe4;
  border-radius: 3px;
  padding: 4px;
  width: 100%;
}

.assigned_cohorts_drop {
  width: 100%;
  padding: 0.28rem;
  border: none;
  vertical-align: middle;
  font-size: 13px;
}
.card-header {
  padding: 0;
  margin-bottom: 0;
  background-color: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  height: 54px;
}
.verrticle {
  line-height: 54px;
}
.verrticle a {
  color: #007bff !important;
}
.badge-blue_light {
  color: #4c8ce4;
  background-color: #fff;
  border: 1px solid #4c8ce4;
}
.cohort_form {
  text-align: left;
  margin-top: 5%;
  margin-left: 0;
}
.cancel-btn1 {
  width: 100px;
  height: 30px;
  background-color: transparent !important;
  border-radius: 4px !important;
  border: 1px solid #1e8fe1 !important;
  cursor: pointer;
  outline: none;
  color: #4c8ce4;
  font-size: 14px;
  line-height: 16px;
}
.cohort-add-btn {
  width: 105px;
  height: 31px;
  cursor: pointer;
  background-color: #4c8ce4;
  border-radius: 4px;
  border: solid 2px #4c8ce4;
  outline: none;
  color: #fff;
}

.cohort-text {
  width: 114px;
  height: 16px;
  flex-grow: 0;
  margin: 5px 16px 3px 0;
  font-family: "Roboto-Regular";
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}

.question_title_cohort {
  font-size: 16px;
  color: #666769;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}
.lang-para-approved {
  padding: 0px 19px 0px 31px;
  margin: 19px 0 -8px -4px;
  font-family: Roboto-Regular;
  font-size: 14px;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #666669;
}
#showCheckboxesCohort {
  font-size: 14px;
  color: #000;
  float: left;
  width: 275px;
  line-height: 30px;
}
.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  // top: 0;
  bottom: 0;
}
.showCheckCohort {
  background-color: #e1e2e2;
  padding: 10px 5px 10px 12px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  font-size: 13px;
  position: relative;
  z-index: 1;
}
.milestone-wrap .form-control {
  font-size: 12px;
  height: 32.5px;
}
.shw_timeline_box {
  position: relative;
  top: 5px;
}

.custom-minus {
  margin-left: -15px !important;
}
.cohortEdit {
  color: #1e8fe1;
  cursor: pointer;
}
.cohort-add-btn:disabled {
  opacity: 0.25;
  background-color: #1e8fe1;
}
.Ass_cohort_brdbtm {
  border-bottom: 1px solid #d3dee3;
  border-top: 1px solid #d3dee3;
}
.question_title.pad-150 {
  padding-left: 150px;
  padding-right: 150px;
}

.milestone-day-readonly.span-block {
  border-right: 0;
  text-align: center;
}
.scr-duration-title {
  font-weight: 700;
  display: inline-block;
  height: auto;
  color: #666669;
  margin: 5px 0px 3px 0;
  font-size: 14px;
}
.scr-milestone-number {
  padding: 3px 5px;
  border-radius: 0;
}

.marginlft {
  margin-right: -10px !important;
}

.switch-button {
  border: solid 1px #c5d1d6;
  border-radius: 4px;
  margin-top: 30px;
}
.switch-button p {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #666669;
  margin: 0 auto;
  max-width: 380px;
  opacity: 0.7;
}
.text-content {
  text-align: end;
}
.studyDeleteIcon {
  position: relative;
  top: 6rem;
  right: 5rem;
}

.rtsm-text {
  font-size: 16px;
}

.rtsm-text p {
  white-space: normal;
}

.horiziontal-rule-line-break {
  height: 0.7px;
  align-self: stretch;
  flex-grow: 0;
  background-color: #ccc;
}

.rtsm-settings {
  width: 100%;
}

.rtsm-settings tr {
  border-top: 2px solid #f4f6f8;
  border-bottom: 2px solid #f4f6f8;
  border-collapse: collapse;
}

.rtsm-settings tr:first-child {
  border-top: none;
}

.rtsm-settings tr:last-child {
  border-bottom: none;
}

.rtsm-settings th {
  background-color: #f4f6f8;
}

.rtsm-settings th,
.rtsm-settings td {
  padding: 8px;
}

.rtsm-settings-wrapper {
  border-radius: 4px;
  border: 2px solid #f4f6f8;
}

/deep/ .rtsm-settings-check-box .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #ccc;
  background-color: #ccc;
}

.fas {
  font-family: "FontAwesome", sans-serif;
}

.manual-start-radio,
.schedule-feature-radio {
  max-width: 500px;
}

/deep/ .enable-disable-disabled .custom-radio .custom-control-label::before {
  box-shadow: 0 0 0 2px #d3d3d3 !important;
}

/deep/ .enable-disable-disabled .custom-radio .custom-control-label::after {
  box-shadow: 0 0 0 2px #a8a8a8 !important;
}

/deep/ .enable-disable-disabled .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #a8a8a8 !important;
}

/deep/ .enable-disable-disabled .custom-control-label {
  color: #a8a8a8 !important;
}

/deep/ .enable-disable-disabled .custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: #fff;
}
</style>
<style lang="scss">
.rtsm-custom {
  .tooltip-inner {
    max-width: 230px;
  }

  .tooltip {
    margin-left: 30px;
  }

  .tooltip .arrow {
    display: none;
  }
}

.rtsm-custom-manual-start {
  .tooltip {
    margin-left: -2px;
  }
}

.rtsm-custom-active {
  .tooltip {
    margin-left: 5px;
    margin-top: -20px;
  }
}
</style>
<style scoped lang="scss" src="@/assets/design-screen.scss"></style>
<style scoped lang="scss" src="@/assets/otp-input.scss"></style>
